<template>
  <div>
    <div><!-- display: flex;justify-content: space-between; -->
      <div>
        <el-form :inline="true" style="text-align:right;">
          <el-form-item :label='$t("time.timeQuery")' class="selectIcon">
            <el-select v-model="searchType" style="width:140px" :size="size">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-show="searchShow && activeName == 'first'">
            <el-date-picker :size="size" style="width:295px" v-model="searchMTime" type="monthrange"
              value-format="yyyy-MM" :picker-options="monthPickerOptions" :range-separator='$t("time.to")'
              :start-placeholder='$t("time.startMonth")' :end-placeholder='$t("time.endMonth")'>
            </el-date-picker><!-- unlink-panels  -->
          </el-form-item>
          <el-form-item v-show="searchShow && activeName == 'second'">
            <el-date-picker :size="size" style="width:305px" v-model="searchDTime" type="daterange"
              :picker-options="datePickerOptions" :range-separator='$t("time.to")'
              :start-placeholder='$t("time.startDate")' :end-placeholder='$t("time.endDate")'>
            </el-date-picker>
          </el-form-item>
          <el-form-item v-show="searchShow && activeName == 'third'">
            <el-date-picker
              v-model="searchYTime[0]"
              :size="size"
              style="width:150px"
              :picker-options="yPickerOption1"
              type="year"
              value-format="yyyy"
              :placeholder="$t('public.select')">
            </el-date-picker>
          </el-form-item>
          <el-form-item v-show="searchShow && activeName == 'third'" label="-">
            <el-date-picker
              v-model="searchYTime[1]"
              :size="size"
              style="width:150px"
              :picker-options="yPickerOption2"
              type="year"
              value-format="yyyy"
              :placeholder="$t('public.select')">
            </el-date-picker>
          </el-form-item>
          <el-form-item v-if="searchShow">
            <el-button type="primary" plain :size="size" style="margin-left:15px;" @click="handleQuery">{{
              $t("public.query")}}</el-button>
          </el-form-item>
          <el-form-item v-if="!searchShow && activeName == 'first'">
            <el-button v-for="item in monthBtns" :key="item.value" :type="showMBtn == item.value ? 'primary' : ''"
              :size="size" style="text-align:center;" @click="quickQuery(item.value)">{{ item.label }}</el-button>
          </el-form-item>
          <el-form-item v-if="!searchShow && activeName == 'second'">
            <el-button v-for="item in dayBtns" :key="item.value" :type="showDBtn == item.value ? 'primary' : ''"
              :size="size" style="text-align:center;" @click="quickQuery(item.value)">{{ item.label }}</el-button>
          </el-form-item>
          <el-form-item v-if="!searchShow && activeName == 'third'">
            <el-button v-for="item in yearBtns" :key="item.value" :type="showYBtn == item.value ? 'primary' : ''"
              :size="size" style="text-align:center;" @click="quickQuery(item.value)">{{ item.label }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button :size="size" type="primary" style="margin-left:10px" @click="download" :loading="downloading">{{
              $t("public.download")}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div style="height: calc(100vh - 245px);overflow: auto;padding-top:10px">
      <div style="padding:0 8px;"> <!-- height:calc(100vh - 143px); -->
        <div v-show="chartAllOrSingle" :style="boderStyle">
          <div style="font-size: 14px;color: #0F1A3A;margin-bottom: 8px;" v-if="mulFuelTypeSelect">
            {{$t("statistics.车队总览")}}：
            <el-select v-model="optionsType" placeholder="请选择" :size="size" @change="fuelTypeChange" :disabled="loadingCharts">
              <el-option
                v-for="item in energyTypes"
                :key="item"
                :label="getEnergyName(item)"
                :value="item">
              </el-option>
            </el-select>
          </div>
          <div>
            <div v-show="isShowPower">
              <!-- 电车统计 -->
              <el-row :gutter="15">
                <el-col :span="8">
                  <el-card class="card" style="padding:0 8px" shadow="hover">
                    <div slot="header">
                      <div style="display: flex;">
                        <div style="">
                          <span class="comptVal">{{ fleetConspt }}</span>
                          <span style="font-size:12px">kW·h</span>
                        </div>
                        <div style="flex:1;text-align:right">
                          <!-- <span class="pcVal" >8.9%</span>
                          <i class="el-icon-top" style="color:red,font-size:24px"></i> -->
                        </div>
                      </div>
                      <div
                        style="margin-top: 5px;color: #303133;opacity: 0.7; font-size:12px; display: flex; justify-content: space-between">
                        <span>{{ $t("statistics.fleetConspt") }}</span>
                        <!-- <span>环比</span> -->
                      </div>
                    </div>
                    <div class="carBody" style="text-align:center">
                      <div v-loading="loadingCharts" :id="'chart_fleetConspt' + type" style="width: 100%;height: 150px;">
                      </div>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="8">
                  <el-card class="card" style="padding:0 8px" shadow="hover">
                    <div slot="header">
                      <div style="display: flex;">
                        <div style="">
                          <span class="comptVal">{{ fleetMileage }}</span>
                          <span style="font-size:12px">km</span>
                        </div>
                        <div style="flex:1;text-align:right">
                          <!-- <span class="pcVal" >8.9%</span>
                          <i class="el-icon-top" style="color:red,font-size:24px"></i> -->
                        </div>
                      </div>
                      <div
                        style="margin-top: 5px;color: #303133;opacity: 0.7; font-size:12px; display: flex; justify-content: space-between">
                        <span>{{ $t("statistics.fleetMileage") }}</span>
                        <!-- <span>环比</span> -->
                      </div>
                    </div>
                    <div class="carBody" style="text-align:center">
                      <div v-loading="loadingCharts" :id="'chart_fleetMileage' + type" style="width: 100%;height: 150px;">
                      </div>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="8">
                  <el-card class="card" style="padding:0 8px" shadow="hover">
                    <div slot="header">
                      <div style="display: flex;">
                        <div style="">
                          <span class="comptVal">{{ avgConspt }}</span>
                          <span style="font-size:12px">kW·h/100km</span>
                        </div>
                        <div style="flex:1;text-align:right">
                          <!-- <span class="pcVal" style="font-size:15px;">8.9%</span>
                          <i class="el-icon-top" style="color:red,font-size:24px"></i> -->
                        </div>
                      </div>
                      <div
                        style="margin-top: 5px;color: #303133;opacity: 0.7; font-size:12px; display: flex; justify-content: space-between">
                        <span>{{ $t("statistics.avgConspt") }}</span>
                        <!-- <span>环比</span> -->
                      </div>
                    </div>
                    <div class="carBody" style="text-align:center">
                      <div v-loading="loadingCharts" :id="'chart_avgConspt' + type" style="width: 100%;height: 150px;">
                      </div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>
            <div v-show="isShowOil" style="margin-top:8px">
              <!-- 油车统计 -->
              <el-row :gutter="15">
                <el-col :span="8">
                  <el-card class="card" style="padding:0 8px" shadow="hover">
                    <div slot="header">
                      <div style="display: flex;">
                        <div style="">
                          <span class="comptVal">{{ fleetOilConspt }}</span>
                          <span style="font-size:12px">L</span>
                        </div>
                        <div style="flex:1;text-align:right">
                          <!-- <span class="pcVal" >8.9%</span>
                          <i class="el-icon-top" style="color:red,font-size:24px"></i> -->
                        </div>
                      </div>
                      <div
                        style="margin-top: 5px;color: #303133;opacity: 0.7; font-size:12px; display: flex; justify-content: space-between">
                        <span>{{ $t("statistics.fleetOilConspt") }}</span>
                        <!-- <span>环比</span> -->
                      </div>
                    </div>
                    <div class="carBody" style="text-align:center">
                      <div v-loading="loadingCharts" :id="'chart_fleetOilConspt' + type" style="width: 100%;height: 150px;">
                      </div>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="8">
                  <el-card class="card" style="padding:0 8px" shadow="hover">
                    <div slot="header">
                      <div style="display: flex;">
                        <div style="">
                          <span class="comptVal">{{ fleetOilMileage }}</span>
                          <span style="font-size:12px">km</span>
                        </div>
                        <div style="flex:1;text-align:right">
                          <!-- <span class="pcVal" >8.9%</span>
                          <i class="el-icon-top" style="color:red,font-size:24px"></i> -->
                        </div>
                      </div>
                      <div
                        style="margin-top: 5px;color: #303133;opacity: 0.7; font-size:12px; display: flex; justify-content: space-between">
                        <span>{{ $t("statistics.fleetOilMileage") }}</span>
                        <!-- <span>环比</span> -->
                      </div>
                    </div>
                    <div class="carBody" style="text-align:center">
                      <div v-loading="loadingCharts" :id="'chart_fleetOilMileage' + type"
                        style="width: 100%;height: 150px;"></div>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="8">
                  <el-card class="card" style="padding:0 8px" shadow="hover">
                    <div slot="header">
                      <div style="display: flex;">
                        <div style="">
                          <span class="comptVal">{{ avgOilConspt }}</span>
                          <span style="font-size:12px">L/100km</span>
                        </div>
                        <div style="flex:1;text-align:right">
                          <!-- <span class="pcVal" style="font-size:15px;">8.9%</span>
                          <i class="el-icon-top" style="color:red,font-size:24px"></i> -->
                        </div>
                      </div>
                      <div
                        style="margin-top: 5px;color: #303133;opacity: 0.7; font-size:12px; display: flex; justify-content: space-between">
                        <span>{{ $t("statistics.avgOilConspt") }}</span>
                        <!-- <span>环比</span> -->
                      </div>
                    </div>
                    <div class="carBody" style="text-align:center">
                      <div v-loading="loadingCharts" :id="'chart_avgOilConspt' + type" style="width: 100%;height: 150px;">
                      </div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>
            <div v-show="optionsType == 6" style="margin-top:8px">
              <!-- 氢燃料 -->
              <el-row :gutter="15">
                <el-col :span="8">
                  <el-card class="card" style="padding:0 8px" shadow="hover">
                    <div slot="header">
                      <div style="display: flex;">
                        <div style="">
                          <span class="comptVal">{{ fleetfuelCellConspt }}</span>
                          <span style="font-size:12px">kg</span>
                        </div>
                        <div style="flex:1;text-align:right">
                        </div>
                      </div>
                      <div
                        style="margin-top: 5px;color: #303133;opacity: 0.7; font-size:12px; display: flex; justify-content: space-between">
                        <span>{{ $t("statistics.车队总氢耗") }}</span>
                      </div>
                    </div>
                    <div class="carBody" style="text-align:center">
                      <div v-loading="loadingCharts" :id="'chart_fleetfuelCellConspt' + type" style="width: 100%;height: 150px;">
                      </div>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="8">
                  <el-card class="card" style="padding:0 8px" shadow="hover">
                    <div slot="header">
                      <div style="display: flex;">
                        <div style="">
                          <span class="comptVal">{{ fleetfuelCellMileage }}</span>
                          <span style="font-size:12px">km</span>
                        </div>
                        <div style="flex:1;text-align:right">
                        </div>
                      </div>
                      <div
                        style="margin-top: 5px;color: #303133;opacity: 0.7; font-size:12px; display: flex; justify-content: space-between">
                        <span>{{ $t("statistics.氢耗总里程") }}</span>
                      </div>
                    </div>
                    <div class="carBody" style="text-align:center">
                      <div v-loading="loadingCharts" :id="'chart_fleetfuelCellMileage' + type"
                        style="width: 100%;height: 150px;"></div>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="8">
                  <el-card class="card" style="padding:0 8px" shadow="hover">
                    <div slot="header">
                      <div style="display: flex;">
                        <div style="">
                          <span class="comptVal">{{ avgfuelCellConspt }}</span>
                          <span style="font-size:12px">kg/100km</span>
                        </div>
                        <div style="flex:1;text-align:right">
                        </div>
                      </div>
                      <div
                        style="margin-top: 5px;color: #303133;opacity: 0.7; font-size:12px; display: flex; justify-content: space-between">
                        <span>{{ $t("statistics.百公里平均氢耗") }}</span>
                      </div>
                    </div>
                    <div class="carBody" style="text-align:center">
                      <div v-loading="loadingCharts" :id="'chart_avgfuelCellConspt' + type" style="width: 100%;height: 150px;">
                      </div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
              
            </div>
            <div v-show="isShowGas" style="margin-top:8px">
              <!-- 气体机统计 -->
              <el-row :gutter="15">
                <el-col :span="8">
                  <el-card class="card" style="padding:0 8px" shadow="hover">
                    <div slot="header">
                      <div style="display: flex;">
                        <div style="">
                          <span class="comptVal">{{ gasUnitChange(fleetGasConspt) }}</span>
                          <span style="font-size:12px">{{gasUnit}}</span>
                        </div>
                        <div style="flex:1;text-align:right">
                        </div>
                      </div>
                      <div
                        style="margin-top: 5px;color: #303133;opacity: 0.7; font-size:12px; display: flex; justify-content: space-between">
                        <span>{{ $t("statistics.车队总气耗") }}</span>
                      </div>
                    </div>
                    <div class="carBody" style="text-align:center">
                      <div v-loading="loadingCharts" :id="'chart_fleetGasConspt' + type" style="width: 100%;height: 150px;">
                      </div>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="8">
                  <el-card class="card" style="padding:0 8px" shadow="hover">
                    <div slot="header">
                      <div style="display: flex;">
                        <div style="">
                          <span class="comptVal">{{ fleetGasMileage }}</span>
                          <span style="font-size:12px">km</span>
                        </div>
                        <div style="flex:1;text-align:right">
                        </div>
                      </div>
                      <div
                        style="margin-top: 5px;color: #303133;opacity: 0.7; font-size:12px; display: flex; justify-content: space-between">
                        <span>{{ $t("statistics.气耗总里程") }}</span>
                      </div>
                    </div>
                    <div class="carBody" style="text-align:center">
                      <div v-loading="loadingCharts" :id="'chart_fleetGasMileage' + type"
                        style="width: 100%;height: 150px;"></div>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="8">
                  <el-card class="card" style="padding:0 8px" shadow="hover">
                    <div slot="header">
                      <div style="display: flex;">
                        <div style="">
                          <span class="comptVal">{{ gasUnitChange(avgGasConspt) }}</span>
                          <span style="font-size:12px">{{gasUnit}}/100km</span>
                        </div>
                        <div style="flex:1;text-align:right">
                        </div>
                      </div>
                      <div
                        style="margin-top: 5px;color: #303133;opacity: 0.7; font-size:12px; display: flex; justify-content: space-between">
                        <span>{{ $t("statistics.百公里平均气耗") }}</span>
                      </div>
                    </div>
                    <div class="carBody" style="text-align:center">
                      <div v-loading="loadingCharts" :id="'chart_avgGasConspt' + type" style="width: 100%;height: 150px;">
                      </div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>
          </div>

        </div>
        <div v-show="chartAllOrSingle" style="margin-top:8px">
          <div :id="'energyDataChart' + type" v-loading="energyDataLoding" style="width: 100%;height: 250px;"></div>
        </div>
        <div v-show="!chartAllOrSingle && fuelType.isPower">
          <div :id="'chart_single_power' + type" v-loading="loading" style="width: 100%;height: 215px;"></div>
        </div>
        <div v-show="!chartAllOrSingle && fuelType.isOil" style="margin-top:8px">
          <div :id="'chart_single_oil' + type" v-loading="loading" style="width: 100%;height: 215px;"></div>
        </div>
        <div v-show="!chartAllOrSingle && fuelType.isfuelCell" style="margin-top:8px">
          <div :id="'chart_single_fuelCell' + type" v-loading="loading" style="width: 100%;height: 215px;"></div>
        </div>
        <div v-show="!chartAllOrSingle && fuelType.isGas" style="margin-top:8px">
          <div :id="'chart_single_gas' + type" v-loading="loading" style="width: 100%;height: 215px;"></div>
        </div>
        <!-- 单车图表容器 -->
        <div :id="'singleChartContainer' + type" style="width:100%"></div>

        <div class="container" style="margin-top:8px">
          <!--:style="{'height':height}"  calc(100vh - 565px) calc(100vh - 765px)  :height="height"-->
          <el-table :size="size" :data="isAllVehicles ? dataList : list" @sort-change='sortChange' border
            v-loading="loading" ref="table">
            <el-table-column :label='$t("public.OrderIndex")' width="105" align="center" prop="id"
             ></el-table-column>
            <el-table-column :label='$t("vehicle.carNo")' align="center" prop="carNo" :min-width="170" sortable="custom"
             ></el-table-column>
            <el-table-column :label='$t("vehicle.ManufactureNo")' align="center" prop="manufactureNo" :min-width="115"
             ></el-table-column>
            <el-table-column :label='$t("statistics.fuelType")' align="center" prop="fuelType" :min-width="110"
             ></el-table-column>
            <el-table-column :label='$t("statistics.statisticalTime")' align="center" prop="statisticalTime"
              :min-width="127" sortable="custom"></el-table-column>
            <el-table-column :label='$t("statistics.runTime")' align="center" prop="runTime" :min-width="130"
              sortable="custom">
              <template slot-scope="scope">{{ timeChange(scope.row.runTime) }}</template>
            </el-table-column>
            <el-table-column :label='$t("statistics.怠速时长")' align="center" prop="OverIdleDuration" :min-width="130"
              sortable="custom">
              <template slot-scope="scope">{{ timeChange(scope.row.OverIdleDuration) }}</template>
            </el-table-column>
            <el-table-column :label='$t("statistics.utilization")' align="center" prop="utilization" :min-width="110"
              sortable="custom">
              <template slot-scope="scope">{{ scope.row.utilization ? scope.row.utilization == 0 ? scope.row.utilization
                : scope.row.utilization + "%" : 0}}</template>
            </el-table-column>
            <el-table-column :label='$t("statistics.mileage")' :min-width="140" align="center" prop="mileage"
              sortable="custom">
              <template slot-scope="scope">{{ Number(scope.row.mileage.toFixed(2)) }}</template>
            </el-table-column>
            <el-table-column :label='$t("statistics.powerConsumption")' align="center" :min-width="195"
              prop="powerConsumption" sortable="custom" v-if="hasPower">
              <template slot-scope="scope">
                {{ setNullForOil(scope.row, scope.row.powerConsumption) }}
              </template>
            </el-table-column>
            <el-table-column :label='$t("statistics.powerConsumptionPer100km")' align="center" :min-width="200"
              prop="powerConsumptionPer100km" sortable="custom" v-if="hasPower">
              <template slot-scope="scope">

                {{ setNullForOil(scope.row, scope.row.powerConsumptionPer100km,"Per100km") }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('statistics.oilConsume')" align="center" :min-width="195" prop="oilConsumption"
              sortable="custom" v-if="hasOil">
              <template slot-scope="scope">
                {{ setNullForEle(scope.row, scope.row.oilConsumption) }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('runState.perOilConsume')" align="center" :min-width="200"
              prop="oilConsumptionPer100km" sortable="custom" v-if="hasOil">
              <template slot-scope="scope">
                {{ setNullForEle(scope.row, scope.row.oilConsumptionPer100km,"Per100km") }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('statistics.耗氢量')+'(kg)'" align="center" :min-width="195" prop="HConsumption"
              sortable="custom" v-if="hasH">
              <template slot-scope="scope">
                {{ setNullForRanliao(scope.row, scope.row.HConsumption) }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('statistics.百公里耗氢')" align="center" :min-width="200"
              prop="HConsumptionPer100km" sortable="custom" v-if="hasH">
              <template slot-scope="scope">
                {{ setNullForRanliao(scope.row, scope.row.HConsumptionPer100km,"Per100km") }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('statistics.气耗')+'('+gasUnit+')'" align="center" :min-width="195" prop="GasConsumption"
              sortable="custom" v-if="hasGas">
              <template slot-scope="scope">
                {{ setNullForGas(scope.row, scope.row.GasConsumption) }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('statistics.百公里耗气')+'('+gasUnit+')'" align="center" :min-width="200"
              prop="GasConsumptionPer100km" sortable="custom" v-if="hasGas">
              <template slot-scope="scope">
                {{ setNullForGas(scope.row, scope.row.GasConsumptionPer100km,"Per100km") }}
              </template>
            </el-table-column>

            <el-table-column :label='$t("statistics.avgSpeed")' :min-width="170" align="center" prop="avgSpeed"
              sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.avgSpeed }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('statistics.电机能耗')" :min-width="115" align="center"
              prop="MotorDriverElecQuantity" v-if="hasPower"></el-table-column>
            <el-table-column :label="$t('statistics.空调能耗')" :min-width="115" align="center"
              prop="AirConditionElecQuantity" v-if="hasPower"></el-table-column>
            <el-table-column :label="$t('statistics.空压机能耗')" :min-width="125" align="center"
              prop="BlastPumpElecQuantity" v-if="hasPower"></el-table-column>
            <el-table-column :label="$t('statistics.dcdc能耗')" :min-width="125" align="center"
              prop="DCConsumeEnergy" v-if="hasPower"></el-table-column>
          </el-table>
        </div>
        <div style="text-align: right;margin-top:8px" class="pagination" v-show="total > 0"> <!--  -->
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
            layout="total, prev, pager, next, sizes" :total="total" @size-change="sizeChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
// import * as echarts from "echarts"
import { mapState } from 'vuex'
import language from '@/utils/getLanguageId'
import settings from "@/settings";
import { convertGasUnit } from "@/utils/longyi";
export default {
  props: {
    activeName: {
      type: String,
      default: "first"
    },
    Init: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "0"
    }
  },
  data() {
    return {
      yPickerOption1:{},
      yPickerOption2:{},
      energyDataChart:undefined,
      vehicles:"",
      mulFuelTypeSelect:true,
      optionsTypes:[],
      optionsType:"",
      defalteQuery:{Params: "mileage",SortFlag:2},
      isAllVehicles: undefined,//标记是否查询全部车辆，因为数据分页，查询具体车辆折线图需要全部数据不能分页，用这个做标记查询是否需要分页
      allVehicles: "",//所有车辆
      chart_single_power: undefined,
      chart_single_fuelCell:undefined,
      chart_single_gas:undefined,
      chart_single_oil: undefined,
      chartAllOrSingle: true,  //展示车队图表信息/单车图表信息
      datePickerOptions: {
        disabledDate(date) {
          return date > new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
        }
      },
      monthPickerOptions: {
        disabledDate(date) {
          var t = new Date();
          var n = new Date(t.getFullYear(), t.getMonth(), 1);

          return date > new Date(n.getTime())
        }
      },
      fleetConspt: 0,
      fleetMileage: 0,
      avgConspt: 0,
      fleetOilConspt: 0,//油车
      fleetOilMileage: 0,
      avgOilConspt: 0,
      fleetfuelCellConspt: 0,//燃料电池
      fleetfuelCellMileage: 0,
      avgfuelCellConspt: 0,
      fleetGasConspt: 0,//气体机
      fleetGasMileage: 0,
      avgGasConspt: 0,

      fleetConsptChartData: 0,
      fleetMileageChartData: 0,
      avgConsptChartData: 0,
      fleetOilConsptChartData: 0,//油车
      fleetOilMileageChartData: 0,
      avgOilConsptChartData: 0,
      fleetfuelCellConsptChartData: 0,//燃料电池
      fleetfuelCellMileageChartData: 0,
      avgfuelCellConsptChartData: 0,
      fleetGasConsptChartData: 0,//气体机
      fleetGasMileageChartData: 0,
      avgGasConsptChartData: 0,
      total: 0,
      chart_fleetConspt: undefined,
      chart_fleetMileage: undefined,
      chart_avgConspt: undefined,
      chart_fleetOilConspt: undefined,
      chart_fleetOilMileage: undefined,
      chart_avgOilConspt: undefined,

      chart_fleetfuelCellConspt: undefined,
      chart_fleetfuelCellMileage: undefined,
      chart_avgfuelCellConspt: undefined,

      chart_fleetGasConspt: undefined,
      chart_fleetGasMileage: undefined,
      chart_avgGasConspt: undefined,

      showYBtn: undefined,
      showMBtn: undefined,
      showDBtn: undefined,
      monthBtns: [],
      dayBtns: [],
      yearBtns: [],
      dataList: [],
      searchDTime: [new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000), new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000)],
      searchMTime: [],
      searchYTime: ["",""],
      options: [],
      beginDate: "",
      endDate: "",
      currentPage: 1,
      pageSize: 10,
      searchType: 0,
      loading: false,
      loadingCharts: false,
      autoWidth: true,
      fuelType: {
        isPower: false,
        isOil: false,
        isfuelCell:false,
        isGas:false,
      },
      LanguageId: 1,
      Params: undefined,//排序参数  
      SortFlag: undefined,//1:升序 2:降序
      downloading: false,
      hasPower: false,
      hasOil: false,
      hasGas: false,
      hasH: false,
      energyDataLoding:false,

      singleCharts: [],// 用来保存所有单车图表实例，方便统一销毁
    }
  },
  computed: {
    boderStyle(){
      if(this.mulFuelTypeSelect){
        return 'border: 1px solid #C5D0E2;border-radius: 4px;padding:8px 4px;'
      }
      return '';
    },
    // 能源类型清单
    energyTypes() {
        return this.$store.getters.energyTypes;
    },
    gasUnit(){
      if(this.$store.getters.gasUnit == "m3") return "m³";
      return this.$store.getters.gasUnit;
    },
    isShowPower(){
      //有电，车队显示
      return this.optionsType == 3 || this.optionsType == 4 || this.optionsType == 5 || this.optionsType == 6;
    },
    isShowOil(){
      // 有油，车队显示
      return this.optionsType == 1 || this.optionsType == 3;
    },
    isShowGas(){
      // 有气体机，车队显示
      return this.optionsType == 2 || this.optionsType == 4;
    },
    searchShow() {
      return this.searchType == 0 ? true : false;
    },
    size() {
      return this.$store.getters.size
    },
    height() {
      if (this.showChartConspt) {
        return "calc(100vh - 761px)"
      } else return "calc(100vh - 561px)"
    },
    ...mapState({
      opened: state => state.app.sidebar.opened,
      selectedVehicles: state => state.app.vehicles.selectedVehicles,
      tree: state => state.app.vehicles.tree,
      appVehicles: state => state.app.vehicles,
    }),
    list() {
      if (!this.isAllVehicles) {
        if (this.dataList != null && this.dataList.length > 0) {
          return this.dataList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
        }
      }
      return [];
    },
  },
  watch: {
    searchYTime: {
      handler() {
        this.setYearOptions() // 只要年份变了，立刻重设禁用规则
      },
      deep: true
    },
    chartAllOrSingle(val) {
      this.$nextTick(function () {
        var myEvent = new Event("resize");
        window.dispatchEvent(myEvent);
      });
    },
    fuelType: {
      handler(newval, oldval) {
        this.$nextTick(function () {
          var myEvent = new Event("resize");
          window.dispatchEvent(myEvent);
        });
      },
      deep: true
    },
    activeName(val) {
      this.$nextTick(function () {
        var myEvent = new Event("resize");
        window.dispatchEvent(myEvent);
      });
    },
    opened() {
      setTimeout(() => {
        this.setResize();
      }, 300)
    },
    Init(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.getEnergyList();
        });
        this.handleQuery();

      }
    }
  },

  methods: {
    setYearOptions() {
      const currentYear = new Date().getFullYear()
      let start;
      let end;
      if(this.searchYTime[0] instanceof Date){
        start = new Date(this.searchYTime[0]).getFullYear();
      }else{
        start = this.searchYTime[0]
      }

      if(this.searchYTime[0] instanceof Date){
        end = new Date(this.searchYTime[1]).getFullYear();
      }else{
        end = this.searchYTime[1]
      }
      // 开始年禁用规则
      this.yPickerOption1 = {
        disabledDate: (date) => {
          const y = date.getFullYear()
          if (y > currentYear) return true
          if (end && y > end) return true
          return false
        }
      }

      // 结束年禁用规则
      this.yPickerOption2 = {
        disabledDate: (date) => {
          const y = date.getFullYear()
          if (y > currentYear) return true
          if (start && y < start) return true
          return false
        }
      }
    },
    // 清空所有单车图表 + DOM
    clearSingleVehicleCharts() {
      // 1. 销毁所有图表实例
      this.singleCharts.forEach(chart => {
        if (chart) chart.dispose();
      });
      this.singleCharts = [];

      // 2. 清空容器里所有DOM
      const container = document.getElementById('singleChartContainer' + this.type);
      if (container) {
        container.innerHTML = '';
      }
    },
    renderSingleVehicleChart(option) {
      const container = document.getElementById('singleChartContainer' + this.type);
      // console.log(option)
      if (!container) return;
      
      // 创建新div
      const div = document.createElement('div');
      div.style.width = '100%';
      div.style.height = '215px';
      container.appendChild(div);

      // 初始化图表
      const chart = echarts.init(div);
      chart.clear();
      chart.setOption(option, true);

      chart.resize();

      // 保存实例，方便后面销毁
      this.singleCharts.push(chart);
    },
    queryAllEnergyData(){
      if(!this.isAllVehicles) return;
      this.energyDataLoding = true;
      let queryType = 0;
      switch(this.activeName){
        case "first":
          queryType = 0;
          break;
        case "second":
          queryType = 1;
          break;
        case "third":
          queryType = 2;
          break;
      }
      this.$api
        .energyInfo({
          companyID: this.$store.getters.operator.CompanyId,
          vehicles: "",
          queryType: queryType,//this.activeName == "first" ? 0 : 1,
          beginDate: this.beginDate,
          endDate: this.endDate,
          OperatorID: this.$store.getters.operator.OperatorId,

          PageNo: 1,
          PageSize: 1000,
          IsExport: 0, // 0是查询 1是下载
          CompanyFlag: 1,//1,查询公司，0查单车
          Unit: this.gasUnit == 'm³' ? 'm3' : this.gasUnit,
        })
        .then((res)=>{
          if(res.code == 200){
            if(res.data){
              this.energyDataLoding = false;
              let y = {};
              let xAxis = [];
              let yMileage = [];

              this.hasPower ? y.power = [this.$t("statistics.powerConsumption"),[]] : null; 
              this.hasOil ? y.oil = [this.$t('statistics.oilConsume'),[]] : null; 
              this.hasGas ? y.gas = [this.$t('statistics.气耗')+'('+this.gasUnit+')',[]] : null; 
              this.hasH ? y.h = [this.$t('statistics.耗氢量')+'(kg)',[]] : null; 

              res.data.forEach((element)=>{
                xAxis.push(element.statisticalTime);
                yMileage.push(element.mileage);
                this.hasPower ? y.power[1].push(element.powerConsumption) : null; 
                this.hasOil ? y.oil[1].push(element.oilConsumption) : null; 
                this.hasGas ? y.gas[1].push(element.GasConsumption) : null; 
                this.hasH ? y.h[1].push(element.HConsumption) : null; 
              })
              // console.log(xAxis,yMileage,y)
              let option = this.setAllEnergyChartOption(xAxis,yMileage,y);
              this.energyDataChart.setOption(option,true);
            }
          }
        })
        .catch((e)=>{
          this.energyDataLoding = false;
        })
    },
    setAllEnergyChartOption(xAxis,yMileage,y){
      let yName = [this.$t("driver.里程")+"(km)"];
      let seriesItem = [
        {
          name: this.$t("driver.里程")+"(km)",
          type: 'line',
          smooth: true,
          data: yMileage,
        },
      ];
      Object.values(y||{}).forEach(value => {
        yName.push(value[0]);
        seriesItem.push(
          {
            name: value[0],
            type: 'line',
            smooth: true,
            data: value[1],
          },
        );
      });
      let option = {
        grid: {
          left: 10,
          right: 32,
          bottom: 0,
          top: 45,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          position: function (point, params, dom, rect, size) {
            // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
            // 提示框位置
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置
            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];
            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];
            // boxWidth > pointX 说明鼠标左边放不下提示框
            if (boxWidth > pointX) {
              x = 5;
            } else { // 左边放的下
              x = pointX - boxWidth;
            }
            // boxHeight > pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else { // 上边放得下
              y = pointY - boxHeight;
            }
            return [x, y];
          }
        },
        title: {
          left: 'center',
          text: "",
        },
        xAxis: [
          {
            type: 'category',
            data: xAxis
          }
        ],
        // yAxis:yAxis,
        yAxis:{type: 'value'},
        series: seriesItem,
        legend: {
          show: true,
          top: "10%",
          data: yName
        },
      };
      
      // console.log(option);
      return option;
    },
    gasUnitChange(value){
      return convertGasUnit(parseFloat(value), this.$store.getters.gasUnit)
    },
    getEnergyName(energyType) {
      if (energyType == 1) {
            return this.$t('oiltype.caiyouji');
        } else if (energyType == 2) {
            return this.$t('oiltype.qitiji');
        }  else if (energyType == 3) {
            return this.$t('oiltype.youdain');
        }  else if (energyType == 4) {
            return this.$t('oiltype.qidian');
        } else if (energyType == 5) {
            return this.$t('oiltype.chundiandong');
        } else if (energyType == 6) {
            return this.$t('oiltype.ranliao');
        }
        return '';
    },
    fuelTypeChange(val){
      this.$nextTick(() => {
        if(this.isShowPower){
          //纯电动
          if(this.chart_fleetConspt) this.chart_fleetConspt.resize();
          if(this.chart_fleetMileage) this.chart_fleetMileage.resize();
          if(this.chart_avgConspt) this.chart_avgConspt.resize();
          
        }else if (this.isShowOil){
          //油车
          if(this.chart_fleetOilConspt) this.chart_fleetOilConspt.resize();
          if(this.chart_fleetOilMileage) this.chart_fleetOilMileage.resize();
          if(this.chart_avgOilConspt) this.chart_avgOilConspt.resize();
          
        }else if(val == 6){
          //燃料电池
          if(this.chart_fleetfuelCellConspt) this.chart_fleetfuelCellConspt.resize();
          if(this.chart_fleetfuelCellMileage) this.chart_fleetfuelCellMileage.resize();
          if(this.chart_avgfuelCellConspt) this.chart_avgfuelCellConspt.resize();
          
        } else if(this.isShowGas){
          //气体机
          if(this.chart_fleetGasConspt) this.chart_fleetGasConspt.resize();
          if(this.chart_fleetGasMileage) this.chart_fleetGasMileage.resize();
          if(this.chart_avgGasConspt) this.chart_avgGasConspt.resize();
          
        }
      })
      this.getEnergyList();
    },
    setNullForGas(row, val, type){
      let fuelTypeOil = this.$t("oiltype.qitiji");//气体机
      // 气体机，不显示电耗等，返回“--”
      if (row.fuelType != fuelTypeOil && val == 0) {
        return "- -";
      } else {
        if(type == "Per100km"){
          if(row.mileage < 1 && row.GasConsumption > 0){
            return "- -";
          }
        }
        return parseFloat(Number(val).toFixed(2))
      }
      return parseFloat(Number(val).toFixed(2))
    },
    setNullForRanliao(row, val, type) {
      let fuelTypeOil = this.$t("oiltype.ranliao");//燃料电池
      // 燃料电池，不显示电耗等，返回“--”
      if (row.fuelType != fuelTypeOil && val == 0) {
        return "- -";
      } else {
        if(type == "Per100km"){
          if(row.mileage < 1 && row.HConsumption > 0){
            return "- -";
          }
        }
        return parseFloat(Number(val).toFixed(2))
      }
      return parseFloat(Number(val).toFixed(2))
    },
    setNullForEle(row, val, type) {
      let fuelTypeOil = this.$t("statistics.柴油机");//柴油
      // 油车，不显示电耗等，返回“--”
      if (row.fuelType != fuelTypeOil && val == 0) {
        return "- -";
      } else {
        if(type == "Per100km"){
          if(row.mileage < 1 && row.oilConsumption > 0){
            return "- -";
          }
        }
        return parseFloat(Number(val).toFixed(2))
      }
      return parseFloat(Number(val).toFixed(2))
    },
    setNullForOil(row, val, type) {
      // 电车，不显示油耗等，返回“--”
      let fuelTypeOil = this.$t("statistics.pureElectric");//纯电动
      if (row.fuelType != fuelTypeOil && val == 0) {
        return "- -";
      } else {
        if(type == "Per100km"){
          if(row.mileage < 1 && row.powerConsumption > 0){
            return "- -";
          }
        }
        return parseFloat(Number(val).toFixed(2))
      }
        return parseFloat(Number(val).toFixed(2))
    },
    setResize() {
      if(this.chartAllOrSingle){
        // 公司全部能耗
        if(this.energyDataChart) this.energyDataChart.resize();
      }
      if(this.chartAllOrSingle && this.isShowPower){
        //电车全部
        if(this.chart_fleetConspt) this.chart_fleetConspt.resize();
        if(this.chart_fleetMileage) this.chart_fleetMileage.resize();
        if(this.chart_avgConspt) this.chart_avgConspt.resize();
      }
      if(this.chartAllOrSingle && this.isShowOil){
        //油车全部
        if(this.chart_fleetOilConspt) this.chart_fleetOilConspt.resize();
        if(this.chart_fleetOilMileage) this.chart_fleetOilMileage.resize();
        if(this.chart_avgOilConspt) this.chart_avgOilConspt.resize();
      }
      if(this.chartAllOrSingle && this.optionsType == "6"){
        //燃料电池全部
        if(this.chart_fleetfuelCellConspt) this.chart_fleetfuelCellConspt.resize();
        if(this.chart_fleetfuelCellMileage) this.chart_fleetfuelCellMileage.resize();
        if(this.chart_avgfuelCellConspt) this.chart_avgfuelCellConspt.resize();
      }
      if(this.chartAllOrSingle && this.isShowGas){
        //气体机全部
        if(this.chart_fleetGasConspt) this.chart_fleetGasConspt.resize();
        if(this.chart_fleetGasMileage) this.chart_fleetGasMileage.resize();
        if(this.chart_avgGasConspt) this.chart_avgGasConspt.resize();
      }
      if(!this.chartAllOrSingle && this.fuelType.isPower){
        //电车单车
        if(this.chart_single_power) this.chart_single_power.resize();
      }
      if(!this.chartAllOrSingle && this.fuelType.isOil){
        //油车单车
        if(this.chart_single_oil) this.chart_single_oil.resize();
      }
      if(!this.chartAllOrSingle && this.fuelType.isfuelCell){
        //燃料单车
        if(this.chart_single_fuelCell) this.chart_single_fuelCell.resize();
      }
      if(!this.chartAllOrSingle && this.fuelType.isGas){
        //气体机
        if(this.chart_single_gas) this.chart_single_gas.resize();
      }
      // this.chart_conspt.resize();

      this.singleCharts.forEach(chart => {
        if (chart) chart.resize()
      })
    },
    sortChange(column) {
      console.log("排序", column.prop, column.order);
      // this.currentPage = 1; // 排序后返回第一页
      // this.dataList = this.dataList.sort(
      //   this.SortFun(column.prop, column.order === "descending")
      // );

      this.Params = column.prop;
      this.SortFlag = column.order == "ascending" ? 1 : column.order ? 2 : undefined;
      this.getList(1);
    },
    timeChange(s) {
      if (s == null || s == 0) return "0";
      let day, hour, minute, second;
      day = parseInt(s / 3600 / 24) == 0 ? "" : parseInt(s / 3600 / 24) + this.$t("statistics.day");
      hour = parseInt(s / 3600 % 24) == 0 ? "" : parseInt(s / 3600 % 24) + this.$t("statistics.小时");
      minute = parseInt(s / 60 % 60) == 0 ? "" : parseInt(s / 60 % 60) + this.$t("statistics.分");
      second = parseInt(s % 60) == 0 ? "" : parseInt(s % 60) + this.$t("statistics.秒");
      // console.log(s,day,hour,minute,second,);
      return day + hour + minute + second;
    },
    getEnergyList() {
      let queryType = 0;
      switch(this.activeName){
        case "first":
          queryType = 2;//月
          break;
        case "second"://日
          queryType = 1;
          break;
        case "third"://年
          queryType = 3;
          break;
      }
      this.loadingCharts = true;
      this.fleetConspt = 0;
      this.fleetMileage = 0;
      this.avgConspt = 0;
      this.fleetOilConspt = 0;
      this.fleetOilMileage = 0;
      this.avgOilConspt = 0;
      this.fleetfuelCellConspt = 0;
      this.fleetfuelCellMileage = 0;
      this.avgfuelCellConspt = 0;
      this.fleetGasConspt = 0;
      this.fleetGasMileage = 0;
      this.avgGasConspt = 0;
      //获取能耗统计数据
      this.$api
        .energyStatistics({
          OperatorID: this.$store.getters.operator.OperatorId,
          SubjectCorpID: this.$store.getters.operator.CompanyId,
          queryType: queryType,//this.type == "0" ? 2 : 1,
          oilType: this.optionsType,//0表示查全部，1柴油，2气体机，3油电，4气电，5纯电动，6燃料电池
        })
        .then((res) => {
          if (res && res.code == 200) {
            //电车
            this.fleetConsptChartData = res.data1.chartList;
            this.fleetMileageChartData = res.data2.chartList;
            this.avgConsptChartData = res.data3.chartList;
            //油车
            this.fleetOilConsptChartData = res.data4.chartList;
            this.fleetOilMileageChartData = res.data5.chartList;
            this.avgOilConsptChartData = res.data6.chartList;

            //燃料电池
            this.fleetfuelCellConsptChartData = res.data7.chartList;
            this.fleetfuelCellMileageChartData = res.data8.chartList;
            this.avgfuelCellConsptChartData = res.data9.chartList;

            // 气体机
            this.fleetGasConsptChartData = res.data10.chartList;
            this.fleetGasMileageChartData = res.data11.chartList;
            this.avgGasConsptChartData = res.data12.chartList;

            if (this.fleetConsptChartData && this.fleetConsptChartData.length > 0) {
              let xAxis_data = [];
              let yAxis_data = [];
              this.fleetConsptChartData.forEach(e => {
                xAxis_data.push(e.Date.substring(e.Date.length - 5));
                yAxis_data.push(e.Vaule);
                this.fleetConspt += e.Vaule;//Value
              });
              this.chart_fleetConspt.setOption({
                xAxis: [
                  {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                      color: "rgba(15,26,58,0.5)",
                      fontSize: 12
                    },
                    axisLine: {
                      lineStyle: {
                        color: "rgba(15,26,58,0.5)",
                      }
                    },
                    data: xAxis_data
                  }
                ],
                tooltip: {
                  trigger: 'axis',
                  position: function (point, params, dom, rect, size) {
                    // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
                    // 提示框位置
                    var x = 0; // x坐标位置
                    var y = 0; // y坐标位置

                    // 当前鼠标位置
                    var pointX = point[0];
                    var pointY = point[1];

                    // 提示框大小
                    var boxWidth = size.contentSize[0];
                    var boxHeight = size.contentSize[1];

                    // boxWidth > pointX 说明鼠标左边放不下提示框
                    if (boxWidth > pointX) {
                      x = 5;
                    } else { // 左边放的下
                      x = pointX - boxWidth;
                    }

                    // boxHeight > pointY 说明鼠标上边放不下提示框
                    if (boxHeight > pointY) {
                      y = 5;
                    } else { // 上边放得下
                      y = pointY - boxHeight;
                    }

                    return [x, y];
                  }
                },
                series: [
                  {
                    name: this.$t("statistics.fleetConspt"),
                    type: 'line',
                    smooth: true,
                    symbol: "none",
                    areaStyle: {
                      color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                          offset: 0, color: '#2A7AFF' // 0% 处的颜色
                        }, {
                          offset: 1, color: '#ffffff' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                      },
                    },
                    lineStyle: {
                      color: "#2A7AFF"
                    },
                    data: yAxis_data
                  },
                ]
              })
            }
            if (this.fleetMileageChartData && this.fleetMileageChartData.length > 0) {
              let xAxis_data = [];
              let yAxis_data = [];
              this.fleetMileageChartData.forEach(e => {
                xAxis_data.push(e.Date.substring(e.Date.length - 5));
                yAxis_data.push(e.Vaule);
                this.fleetMileage += e.Vaule;
              });
              this.fleetMileage = parseFloat(this.fleetMileage.toFixed(2));
              this.chart_fleetMileage.setOption({
                xAxis: [
                  {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                      color: "rgba(15,26,58,0.5)",
                      fontSize: 12
                    },
                    axisLine: {
                      lineStyle: {
                        color: "rgba(15,26,58,0.5)",
                      }
                    },
                    data: xAxis_data
                  }
                ],
                tooltip: {
                  trigger: 'axis',
                  position: function (point, params, dom, rect, size) {
                    // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
                    // 提示框位置
                    var x = 0; // x坐标位置
                    var y = 0; // y坐标位置

                    // 当前鼠标位置
                    var pointX = point[0];
                    var pointY = point[1];

                    // 提示框大小
                    var boxWidth = size.contentSize[0];
                    var boxHeight = size.contentSize[1];

                    // boxWidth > pointX 说明鼠标左边放不下提示框
                    if (boxWidth > pointX) {
                      x = 5;
                    } else { // 左边放的下
                      x = pointX - boxWidth;
                    }

                    // boxHeight > pointY 说明鼠标上边放不下提示框
                    if (boxHeight > pointY) {
                      y = 5;
                    } else { // 上边放得下
                      y = pointY - boxHeight;
                    }

                    return [x, y];
                  }
                },
                series: [
                  {
                    name: this.$t("statistics.fleetMileage"),
                    type: 'line',
                    smooth: true,
                    symbol: "none",
                    areaStyle: {
                      color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                          offset: 0, color: '#2A7AFF' // 0% 处的颜色
                        }, {
                          offset: 1, color: '#ffffff' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                      },
                    },
                    lineStyle: {
                      color: "#2A7AFF"
                    },
                    data: yAxis_data
                  },
                ]
              })
            }
            if (this.avgConsptChartData && this.avgConsptChartData.length > 0) {
              let xAxis_data = [];
              let yAxis_data = [];
              let avgSum = 0;
              this.avgConsptChartData.forEach(e => {
                xAxis_data.push(e.Date.substring(e.Date.length - 5));
                yAxis_data.push(e.Vaule);
                avgSum += e.Vaule;
              });
              // this.avgConspt = (avgSum / 7).toFixed(2);
              this.avgConspt = this.fleetMileage != 0 ? ((this.fleetConspt / this.fleetMileage) * 100).toFixed(2) : 0;
              this.chart_avgConspt.setOption({
                xAxis: [
                  {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                      color: "rgba(15,26,58,0.5)",
                      fontSize: 12
                    },
                    axisLine: {
                      lineStyle: {
                        color: "rgba(15,26,58,0.5)",
                      }
                    },
                    data: xAxis_data
                  }
                ],
                tooltip: {
                  trigger: 'axis',
                  position: function (point, params, dom, rect, size) {
                    // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
                    // 提示框位置
                    var x = 0; // x坐标位置
                    var y = 0; // y坐标位置

                    // 当前鼠标位置
                    var pointX = point[0];
                    var pointY = point[1];

                    // 提示框大小
                    var boxWidth = size.contentSize[0];
                    var boxHeight = size.contentSize[1];

                    // boxWidth > pointX 说明鼠标左边放不下提示框
                    if (boxWidth > pointX) {
                      x = 5;
                    } else { // 左边放的下
                      x = pointX - boxWidth;
                    }

                    // boxHeight > pointY 说明鼠标上边放不下提示框
                    if (boxHeight > pointY) {
                      y = 5;
                    } else { // 上边放得下
                      y = pointY - boxHeight;
                    }

                    return [x, y];
                  }
                },
                series: [
                  {
                    name: this.$t("statistics.avgConspt"),
                    type: 'line',
                    smooth: true,
                    symbol: "none",
                    areaStyle: {
                      color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                          offset: 0, color: '#2A7AFF' // 0% 处的颜色
                        }, {
                          offset: 1, color: '#ffffff' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                      },
                    },
                    lineStyle: {
                      color: "#2A7AFF"
                    },
                    data: yAxis_data
                  },
                ]
              })
            }


            if (this.fleetOilConsptChartData && this.fleetOilConsptChartData.length > 0) {
              let xAxis_data = [];
              let yAxis_data = [];
              this.fleetOilConsptChartData.forEach(e => {
                xAxis_data.push(e.Date.substring(e.Date.length - 5));
                yAxis_data.push(e.Vaule);
                this.fleetOilConspt += e.Vaule;//Value
              });
              this.chart_fleetOilConspt.setOption({
                xAxis: [
                  {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                      color: "rgba(15,26,58,0.5)",
                      fontSize: 12
                    },
                    axisLine: {
                      lineStyle: {
                        color: "rgba(15,26,58,0.5)",
                      }
                    },
                    data: xAxis_data
                  }
                ],
                tooltip: {
                  trigger: 'axis',
                  position: function (point, params, dom, rect, size) {
                    // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
                    // 提示框位置
                    var x = 0; // x坐标位置
                    var y = 0; // y坐标位置

                    // 当前鼠标位置
                    var pointX = point[0];
                    var pointY = point[1];

                    // 提示框大小
                    var boxWidth = size.contentSize[0];
                    var boxHeight = size.contentSize[1];

                    // boxWidth > pointX 说明鼠标左边放不下提示框
                    if (boxWidth > pointX) {
                      x = 5;
                    } else { // 左边放的下
                      x = pointX - boxWidth;
                    }

                    // boxHeight > pointY 说明鼠标上边放不下提示框
                    if (boxHeight > pointY) {
                      y = 5;
                    } else { // 上边放得下
                      y = pointY - boxHeight;
                    }

                    return [x, y];
                  }
                },
                series: [
                  {
                    name: this.$t("statistics.fleetOilConspt"),
                    type: 'line',
                    smooth: true,
                    symbol: "none",
                    areaStyle: {
                      color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                          offset: 0, color: '#2A7AFF' // 0% 处的颜色
                        }, {
                          offset: 1, color: '#ffffff' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                      },
                    },
                    lineStyle: {
                      color: "#2A7AFF"
                    },
                    data: yAxis_data
                  },
                ]
              })
            }
            if (this.fleetOilMileageChartData && this.fleetOilMileageChartData.length > 0) {
              let xAxis_data = [];
              let yAxis_data = [];
              this.fleetOilMileageChartData.forEach(e => {
                xAxis_data.push(e.Date.substring(e.Date.length - 5));
                yAxis_data.push(e.Vaule);
                this.fleetOilMileage += e.Vaule;
              });
              this.fleetOilMileage = parseFloat(this.fleetOilMileage.toFixed(2));
              this.chart_fleetOilMileage.setOption({
                xAxis: [
                  {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                      color: "rgba(15,26,58,0.5)",
                      fontSize: 12
                    },
                    axisLine: {
                      lineStyle: {
                        color: "rgba(15,26,58,0.5)",
                      }
                    },
                    data: xAxis_data
                  }
                ],
                tooltip: {
                  trigger: 'axis',
                  position: function (point, params, dom, rect, size) {
                    // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
                    // 提示框位置
                    var x = 0; // x坐标位置
                    var y = 0; // y坐标位置

                    // 当前鼠标位置
                    var pointX = point[0];
                    var pointY = point[1];

                    // 提示框大小
                    var boxWidth = size.contentSize[0];
                    var boxHeight = size.contentSize[1];

                    // boxWidth > pointX 说明鼠标左边放不下提示框
                    if (boxWidth > pointX) {
                      x = 5;
                    } else { // 左边放的下
                      x = pointX - boxWidth;
                    }

                    // boxHeight > pointY 说明鼠标上边放不下提示框
                    if (boxHeight > pointY) {
                      y = 5;
                    } else { // 上边放得下
                      y = pointY - boxHeight;
                    }

                    return [x, y];
                  }
                },
                series: [
                  {
                    name: this.$t("statistics.fleetOilMileage"),
                    type: 'line',
                    smooth: true,
                    symbol: "none",
                    areaStyle: {
                      color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                          offset: 0, color: '#2A7AFF' // 0% 处的颜色
                        }, {
                          offset: 1, color: '#ffffff' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                      },
                    },
                    lineStyle: {
                      color: "#2A7AFF"
                    },
                    data: yAxis_data
                  },
                ]
              })
            }
            if (this.avgOilConsptChartData && this.avgOilConsptChartData.length > 0) {
              let xAxis_data = [];
              let yAxis_data = [];
              let avgOilSum = 0;
              this.avgOilConsptChartData.forEach(e => {
                xAxis_data.push(e.Date.substring(e.Date.length - 5));
                yAxis_data.push(e.Vaule);
                avgOilSum += e.Vaule;
              });
              // this.avgConspt = (avgSum / 7).toFixed(2);
              this.avgOilConspt = this.fleetOilMileage != 0 ? ((this.fleetOilConspt / this.fleetOilMileage) * 100).toFixed(2) : 0;
              this.chart_avgOilConspt.setOption({
                xAxis: [
                  {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                      color: "rgba(15,26,58,0.5)",
                      fontSize: 12
                    },
                    axisLine: {
                      lineStyle: {
                        color: "rgba(15,26,58,0.5)",
                      }
                    },
                    data: xAxis_data
                  }
                ],
                tooltip: {
                  trigger: 'axis',
                  position: function (point, params, dom, rect, size) {
                    // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
                    // 提示框位置
                    var x = 0; // x坐标位置
                    var y = 0; // y坐标位置

                    // 当前鼠标位置
                    var pointX = point[0];
                    var pointY = point[1];

                    // 提示框大小
                    var boxWidth = size.contentSize[0];
                    var boxHeight = size.contentSize[1];

                    // boxWidth > pointX 说明鼠标左边放不下提示框
                    if (boxWidth > pointX) {
                      x = 5;
                    } else { // 左边放的下
                      x = pointX - boxWidth;
                    }

                    // boxHeight > pointY 说明鼠标上边放不下提示框
                    if (boxHeight > pointY) {
                      y = 5;
                    } else { // 上边放得下
                      y = pointY - boxHeight;
                    }

                    return [x, y];
                  }
                },
                series: [
                  {
                    name: this.$t("statistics.avgOilConspt"),
                    type: 'line',
                    smooth: true,
                    symbol: "none",
                    areaStyle: {
                      color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                          offset: 0, color: '#2A7AFF' // 0% 处的颜色
                        }, {
                          offset: 1, color: '#ffffff' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                      },
                    },
                    lineStyle: {
                      color: "#2A7AFF"
                    },
                    data: yAxis_data
                  },
                ]
              })
            }

            if (this.fleetfuelCellConsptChartData && this.fleetfuelCellConsptChartData.length > 0) {
              let xAxis_data = [];
              let yAxis_data = [];
              this.fleetfuelCellConsptChartData.forEach(e => {
                xAxis_data.push(e.Date.substring(e.Date.length - 5));
                yAxis_data.push(e.Vaule);
                this.fleetfuelCellConspt += e.Vaule;//Value
              });
              this.fleetfuelCellConspt = parseFloat(this.fleetfuelCellConspt.toFixed(2));
              this.chart_fleetfuelCellConspt.setOption({
                xAxis: [
                  {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                      color: "rgba(15,26,58,0.5)",
                      fontSize: 12
                    },
                    axisLine: {
                      lineStyle: {
                        color: "rgba(15,26,58,0.5)",
                      }
                    },
                    data: xAxis_data
                  }
                ],
                tooltip: {
                  trigger: 'axis',
                  position: function (point, params, dom, rect, size) {
                    // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
                    // 提示框位置
                    var x = 0; // x坐标位置
                    var y = 0; // y坐标位置

                    // 当前鼠标位置
                    var pointX = point[0];
                    var pointY = point[1];

                    // 提示框大小
                    var boxWidth = size.contentSize[0];
                    var boxHeight = size.contentSize[1];

                    // boxWidth > pointX 说明鼠标左边放不下提示框
                    if (boxWidth > pointX) {
                      x = 5;
                    } else { // 左边放的下
                      x = pointX - boxWidth;
                    }

                    // boxHeight > pointY 说明鼠标上边放不下提示框
                    if (boxHeight > pointY) {
                      y = 5;
                    } else { // 上边放得下
                      y = pointY - boxHeight;
                    }

                    return [x, y];
                  }
                },
                series: [
                  {
                    name: this.$t("statistics.车队总氢耗"),
                    type: 'line',
                    smooth: true,
                    symbol: "none",
                    areaStyle: {
                      color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                          offset: 0, color: '#2A7AFF' // 0% 处的颜色
                        }, {
                          offset: 1, color: '#ffffff' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                      },
                    },
                    lineStyle: {
                      color: "#2A7AFF"
                    },
                    data: yAxis_data
                  },
                ]
              })
            }
            if (this.fleetfuelCellMileageChartData && this.fleetfuelCellMileageChartData.length > 0) {
              let xAxis_data = [];
              let yAxis_data = [];
              this.fleetfuelCellMileageChartData.forEach(e => {
                xAxis_data.push(e.Date.substring(e.Date.length - 5));
                yAxis_data.push(e.Vaule);
                this.fleetfuelCellMileage += e.Vaule;
              });
              this.fleetfuelCellMileage = parseFloat(this.fleetfuelCellMileage.toFixed(2));
              this.chart_fleetfuelCellMileage.setOption({
                xAxis: [
                  {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                      color: "rgba(15,26,58,0.5)",
                      fontSize: 12
                    },
                    axisLine: {
                      lineStyle: {
                        color: "rgba(15,26,58,0.5)",
                      }
                    },
                    data: xAxis_data
                  }
                ],
                tooltip: {
                  trigger: 'axis',
                  position: function (point, params, dom, rect, size) {
                    // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
                    // 提示框位置
                    var x = 0; // x坐标位置
                    var y = 0; // y坐标位置

                    // 当前鼠标位置
                    var pointX = point[0];
                    var pointY = point[1];

                    // 提示框大小
                    var boxWidth = size.contentSize[0];
                    var boxHeight = size.contentSize[1];

                    // boxWidth > pointX 说明鼠标左边放不下提示框
                    if (boxWidth > pointX) {
                      x = 5;
                    } else { // 左边放的下
                      x = pointX - boxWidth;
                    }

                    // boxHeight > pointY 说明鼠标上边放不下提示框
                    if (boxHeight > pointY) {
                      y = 5;
                    } else { // 上边放得下
                      y = pointY - boxHeight;
                    }

                    return [x, y];
                  }
                },
                series: [
                  {
                    name: this.$t("statistics.氢耗总里程"),
                    type: 'line',
                    smooth: true,
                    symbol: "none",
                    areaStyle: {
                      color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                          offset: 0, color: '#2A7AFF' // 0% 处的颜色
                        }, {
                          offset: 1, color: '#ffffff' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                      },
                    },
                    lineStyle: {
                      color: "#2A7AFF"
                    },
                    data: yAxis_data
                  },
                ]
              })
            }
            if (this.avgfuelCellConsptChartData && this.avgfuelCellConsptChartData.length > 0) {
              let xAxis_data = [];
              let yAxis_data = [];
              let avgfuelCellSum = 0;
              this.avgfuelCellConsptChartData.forEach(e => {
                xAxis_data.push(e.Date.substring(e.Date.length - 5));
                yAxis_data.push(e.Vaule);
                avgfuelCellSum += e.Vaule;
              });
              // this.avgConspt = (avgSum / 7).toFixed(2);
              this.avgfuelCellConspt = this.fleetfuelCellMileage != 0 ? ((this.fleetfuelCellConspt / this.fleetfuelCellMileage) * 100).toFixed(2) : 0;
              this.chart_avgfuelCellConspt.setOption({
                xAxis: [
                  {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                      color: "rgba(15,26,58,0.5)",
                      fontSize: 12
                    },
                    axisLine: {
                      lineStyle: {
                        color: "rgba(15,26,58,0.5)",
                      }
                    },
                    data: xAxis_data
                  }
                ],
                tooltip: {
                  trigger: 'axis',
                  position: function (point, params, dom, rect, size) {
                    // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
                    // 提示框位置
                    var x = 0; // x坐标位置
                    var y = 0; // y坐标位置

                    // 当前鼠标位置
                    var pointX = point[0];
                    var pointY = point[1];

                    // 提示框大小
                    var boxWidth = size.contentSize[0];
                    var boxHeight = size.contentSize[1];

                    // boxWidth > pointX 说明鼠标左边放不下提示框
                    if (boxWidth > pointX) {
                      x = 5;
                    } else { // 左边放的下
                      x = pointX - boxWidth;
                    }

                    // boxHeight > pointY 说明鼠标上边放不下提示框
                    if (boxHeight > pointY) {
                      y = 5;
                    } else { // 上边放得下
                      y = pointY - boxHeight;
                    }

                    return [x, y];
                  }
                },
                series: [
                  {
                    name: this.$t("statistics.百公里平均氢耗"),
                    type: 'line',
                    smooth: true,
                    symbol: "none",
                    areaStyle: {
                      color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                          offset: 0, color: '#2A7AFF' // 0% 处的颜色
                        }, {
                          offset: 1, color: '#ffffff' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                      },
                    },
                    lineStyle: {
                      color: "#2A7AFF"
                    },
                    data: yAxis_data
                  },
                ]
              })
            }
            
            if (this.fleetGasConsptChartData && this.fleetGasConsptChartData.length > 0) {
              let xAxis_data = [];
              let yAxis_data = [];
              this.fleetGasConsptChartData.forEach(e => {
                xAxis_data.push(e.Date.substring(e.Date.length - 5));
                yAxis_data.push(e.Vaule);
                this.fleetGasConspt += e.Vaule;//Value
              });
              this.fleetGasConspt = parseFloat(this.fleetGasConspt.toFixed(2));
              if(this.gasUnit == "m3"){
                this.fleetGasConspt = this.gasUnitChange(this.fleetGasConspt);
              }
              this.chart_fleetGasConspt.setOption({
                xAxis: [
                  {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                      color: "rgba(15,26,58,0.5)",
                      fontSize: 12
                    },
                    axisLine: {
                      lineStyle: {
                        color: "rgba(15,26,58,0.5)",
                      }
                    },
                    data: xAxis_data
                  }
                ],
                tooltip: {
                  trigger: 'axis',
                  position: function (point, params, dom, rect, size) {
                    // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
                    // 提示框位置
                    var x = 0; // x坐标位置
                    var y = 0; // y坐标位置

                    // 当前鼠标位置
                    var pointX = point[0];
                    var pointY = point[1];

                    // 提示框大小
                    var boxWidth = size.contentSize[0];
                    var boxHeight = size.contentSize[1];

                    // boxWidth > pointX 说明鼠标左边放不下提示框
                    if (boxWidth > pointX) {
                      x = 5;
                    } else { // 左边放的下
                      x = pointX - boxWidth;
                    }

                    // boxHeight > pointY 说明鼠标上边放不下提示框
                    if (boxHeight > pointY) {
                      y = 5;
                    } else { // 上边放得下
                      y = pointY - boxHeight;
                    }

                    return [x, y];
                  }
                },
                series: [
                  {
                    name: this.$t("statistics.车队总气耗"),
                    type: 'line',
                    smooth: true,
                    symbol: "none",
                    areaStyle: {
                      color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                          offset: 0, color: '#2A7AFF' // 0% 处的颜色
                        }, {
                          offset: 1, color: '#ffffff' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                      },
                    },
                    lineStyle: {
                      color: "#2A7AFF"
                    },
                    data: yAxis_data
                  },
                ]
              })
            }
            if (this.fleetGasMileageChartData && this.fleetGasMileageChartData.length > 0) {
              let xAxis_data = [];
              let yAxis_data = [];
              this.fleetGasMileageChartData.forEach(e => {
                xAxis_data.push(e.Date.substring(e.Date.length - 5));
                yAxis_data.push(e.Vaule);
                this.fleetGasMileage += e.Vaule;
              });
              this.fleetGasMileage = parseFloat(this.fleetGasMileage.toFixed(2));
              if(this.gasUnit == "m3"){
                this.fleetGasMileage = this.gasUnitChange(this.fleetGasMileage);
              }
              this.chart_fleetGasMileage.setOption({
                xAxis: [
                  {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                      color: "rgba(15,26,58,0.5)",
                      fontSize: 12
                    },
                    axisLine: {
                      lineStyle: {
                        color: "rgba(15,26,58,0.5)",
                      }
                    },
                    data: xAxis_data
                  }
                ],
                tooltip: {
                  trigger: 'axis',
                  position: function (point, params, dom, rect, size) {
                    // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
                    // 提示框位置
                    var x = 0; // x坐标位置
                    var y = 0; // y坐标位置

                    // 当前鼠标位置
                    var pointX = point[0];
                    var pointY = point[1];

                    // 提示框大小
                    var boxWidth = size.contentSize[0];
                    var boxHeight = size.contentSize[1];

                    // boxWidth > pointX 说明鼠标左边放不下提示框
                    if (boxWidth > pointX) {
                      x = 5;
                    } else { // 左边放的下
                      x = pointX - boxWidth;
                    }

                    // boxHeight > pointY 说明鼠标上边放不下提示框
                    if (boxHeight > pointY) {
                      y = 5;
                    } else { // 上边放得下
                      y = pointY - boxHeight;
                    }

                    return [x, y];
                  }
                },
                series: [
                  {
                    name: this.$t("statistics.气耗总里程"),
                    type: 'line',
                    smooth: true,
                    symbol: "none",
                    areaStyle: {
                      color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                          offset: 0, color: '#2A7AFF' // 0% 处的颜色
                        }, {
                          offset: 1, color: '#ffffff' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                      },
                    },
                    lineStyle: {
                      color: "#2A7AFF"
                    },
                    data: yAxis_data
                  },
                ]
              })
            }
            if (this.avgGasConsptChartData && this.avgGasConsptChartData.length > 0) {
              let xAxis_data = [];
              let yAxis_data = [];
              let avgGasSum = 0;
              this.avgGasConsptChartData.forEach(e => {
                xAxis_data.push(e.Date.substring(e.Date.length - 5));
                yAxis_data.push(e.Vaule);
                avgGasSum += e.Vaule;
              });
              // this.avgConspt = (avgSum / 7).toFixed(2);
              this.avgGasConspt = this.fleetGasMileage != 0 ? ((this.fleetGasConspt / this.fleetGasMileage) * 100).toFixed(2) : 0;
              this.chart_avgGasConspt.setOption({
                xAxis: [
                  {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                      color: "rgba(15,26,58,0.5)",
                      fontSize: 12
                    },
                    axisLine: {
                      lineStyle: {
                        color: "rgba(15,26,58,0.5)",
                      }
                    },
                    data: xAxis_data
                  }
                ],
                tooltip: {
                  trigger: 'axis',
                  position: function (point, params, dom, rect, size) {
                    // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
                    // 提示框位置
                    var x = 0; // x坐标位置
                    var y = 0; // y坐标位置

                    // 当前鼠标位置
                    var pointX = point[0];
                    var pointY = point[1];

                    // 提示框大小
                    var boxWidth = size.contentSize[0];
                    var boxHeight = size.contentSize[1];

                    // boxWidth > pointX 说明鼠标左边放不下提示框
                    if (boxWidth > pointX) {
                      x = 5;
                    } else { // 左边放的下
                      x = pointX - boxWidth;
                    }

                    // boxHeight > pointY 说明鼠标上边放不下提示框
                    if (boxHeight > pointY) {
                      y = 5;
                    } else { // 上边放得下
                      y = pointY - boxHeight;
                    }

                    return [x, y];
                  }
                },
                series: [
                  {
                    name: this.$t("statistics.百公里平均气耗"),
                    type: 'line',
                    smooth: true,
                    symbol: "none",
                    areaStyle: {
                      color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                          offset: 0, color: '#2A7AFF' // 0% 处的颜色
                        }, {
                          offset: 1, color: '#ffffff' // 100% 处的颜色
                        }],
                        global: false // 缺省为 false
                      },
                    },
                    lineStyle: {
                      color: "#2A7AFF"
                    },
                    data: yAxis_data
                  },
                ]
              })
            }



            this.loadingCharts = false;
          }
        })
        .catch((res) => {
          this.loadingCharts = false;
        })
    },
    secondsToHMS(seconds) {
      // 计算小时
      const hours = Math.floor(seconds / 3600);
      // 计算分钟
      const minutes = Math.floor((seconds % 3600) / 60);
      // 计算秒钟
      const secs = seconds % 60;

      // 格式化小时、分钟和秒钟
      const formattedHours = hours.toString().padStart(2, '0');
      const formattedMinutes = minutes.toString().padStart(2, '0');
      const formattedSecs = secs.toString().padStart(2, '0');

      return `${formattedHours}:${formattedMinutes}:${formattedSecs}`;
    },
    getSelectedVehicles() {
      this.vehicles = "";
      for (let k = 0; k < this.selectedVehicles.length; k++) {
        if (this.selectedVehicles[k].treeLevel == 5) {
          this.vehicles = this.vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return this.vehicles.substring(0, this.vehicles.length - 1);
    },
    handleQuery(e) {
      switch(this.activeName){
        case "first":
          if(this.searchMTime==''||this.searchMTime==null||this.searchMTime==undefined){
            this.$message.warning(this.$t("vehicleInfo.selectusedate"));
            return;
          }
          var isInit = this.searchMTime[0] instanceof Date && !isNaN(this.searchMTime[0].getTime());
          this.beginDate = isInit ? this.format(this.searchMTime[0], "yyyy-MM-01") : this.searchMTime[0] + "-01";
          this.endDate = isInit ? this.format(this.searchMTime[1], "yyyy-MM" + "-" + this.getCountDays(this.searchMTime[1])) : this.searchMTime[1] + "-" + this.getCountDays(this.searchMTime[1]);
          break;
        case "second":
          if(this.searchDTime==''||this.searchDTime==null){
            this.$message.warning(this.$t("vehicleInfo.selectusedate"));
            return;
          }
          this.beginDate = this.format(this.searchDTime[0], "yyyy-MM-dd");
          this.endDate = this.format(this.searchDTime[1], "yyyy-MM-dd");
          break;
        case "third":
          if(this.searchYTime.includes('')||this.searchYTime.includes(null)){
            this.$message.warning("请选择日期");
            return;
          }
          var isInitb = this.searchYTime[0] instanceof Date && !isNaN(this.searchYTime[0].getTime());
          var isInite = this.searchYTime[1] instanceof Date && !isNaN(this.searchYTime[1].getTime());
          this.beginDate = isInitb ? this.format(this.searchYTime[0], "yyyy-01-01") : this.searchYTime[0]+ "-01-01";
          this.endDate = isInite ? this.format(this.searchYTime[1], "yyyy-12-31") : this.searchYTime[1]+"-12-31";
          // console.log(this.beginDate,this.endDate)
          // return;
          break;
      }
      // this.beginDate =
      //   (this.searchDTime != null || this.searchMTime != null) && (this.searchDTime[0] != undefined || this.searchMTime[0] != undefined)
      //     ? (this.activeName == "first" ? (isInit ? this.format(this.searchMTime[0], "yyyy-MM-01") : this.searchMTime[0] + "-01") : this.format(this.searchDTime[0], "yyyy-MM-dd"))
      //     : "";
      // this.endDate =
      //   (this.searchDTime != null || this.searchMTime != null) && (this.searchDTime[1] != undefined || this.searchMTime[1] != undefined)
      //     ? (this.activeName == "first" ? (isInit ? this.format(this.searchMTime[1], "yyyy-MM" + "-" + this.getCountDays(this.searchMTime[1])) : this.searchMTime[1] + "-" + this.getCountDays(this.searchMTime[1])) : this.format(this.searchDTime[1], "yyyy-MM-dd"))
      //     : "";
      // console.log(this.beginDate,this.endDate);
      this.vehicles = this.getSelectedVehicles();
      this.isAllVehicles = this.vehicles == "" ? true : this.vehicles.split(",").length == this.tree[this.$store.getters.operator.CompanyId].totalCount;
      this.currentPage = 1;
      this.$refs.table.clearSort();
      this.SortFlag = undefined;//清空排序条件
      this.getList();
      this.queryAllEnergyData();
    },
    // 获取是否存在油车、电车
    getCarType(val) {
      //val 车辆类型数组 1 柴油 2 气体机 3 油电 4 气电 5 纯电动  6 燃料电池
      // let power;
      // let oil;
      // let fuelCell;
      // let gas;
      // power = val.filter((e) => {
      //   return e == 5 || e == 3 || e == 4 || e == 6;
      // });
      // oil = val.filter((e) => {
      //   return e == 1 || e == 3;
      // })
      // fuelCell = val.filter((e) => {
      //   return e == 6;
      // })
      // gas = val.filter((e)=>{
      //   return e == 2 || e == 4;
      // })
      // this.fuelType.isPower = power.length > 1 ? true : false;
      // this.fuelType.isOil = oil.length > 1 ? true : false;
      // this.fuelType.isfuelCell = fuelCell.length > 1 ? true : false;
      // this.fuelType.isGas = gas.length > 1 ? true : false;

      // 1 柴油 2 气体机 3 油电 4 气电 5 纯电动 6 燃料电池
      let typeCount = {1: 0,2: 0,3: 0,4: 0,5: 0,6: 0};
      // 统计每类车辆数量
      for (let i = 0; i < val.length; i++) {
        const type = val[i];
        if (typeCount[type] !== undefined) {
          typeCount[type]++;
        }
      }
      this.fuelType.isPower = typeCount['3'] > 1 || typeCount['4']>1||typeCount['5']>1;
      this.fuelType.isOil = typeCount['1']>1||typeCount['3']>1;
      this.fuelType.isfuelCell = typeCount['6']>1;
      this.fuelType.isGas = typeCount['2']>1||typeCount['4']>1;

    },
    setChartCompare(legend,xAxis_data,queryType,yName,queryType2,yName2){
      // 单车添加里程对比，1里程，2燃耗（可能是混合类型2个燃耗，都需要显示）
      let item = 0;  //
      let yMileage = [];
      let y1 = [];
      let y2 = [];
      let series_ = [];
      tiaochu: for (let dt = 0; dt < this.dataList.length; dt++) {  //遍历dataList数据，找跟x坐标时间对应的数据，一个车号在一个时间只有一条数据(一对一对一关系)
        if (this.dataList[dt].vid == legend[0].vid) {   //锁定车号，找时间点对应--数据
          for (item; item < xAxis_data.length;) {   //根据时间为x坐标来push添加对应时间点的y轴数据
            if (xAxis_data[item] == this.dataList[dt].statisticalTime) {
              yMileage.push(this.dataList[dt].mileage.toFixed(2));
              y1.push(this.dataList[dt][queryType]);
              yName2 ? y2.push(this.dataList[dt][queryType2]):null;
              item = item + 1;
              //  continue;
              continue tiaochu;  //一个车号在一个时间点只有一个数据，找到后说明应该往datalist的下一条数据继续找下一个时间点的对应数据
              //如果不跳出，会用该已经找到的dataList继续往下找时间点，但dataList和时间点是一对一关系，就会进入else语句，添加进0的无用数据
            }
            else {
              yMileage.push(0);
              y1.push(0);
              yName2 ? y2.push(0) : null;
              item = item + 1;  //不跳出，因为该条dataList数据还没找到对应时间点，应在时间里继续遍历找对应时间点
              // continue;
              // continue tiaochu;
            }
          }
        }
      }
      series_ = [
        {
          name: this.$t("driver.里程"),
          type: 'line',
          smooth: true,
          data: yMileage,
        },
        {
          name: yName,//,
          type: 'line',
          smooth: true,
          // yAxisIndex: 1,
          data: y1,
        }
      ]

      yName2 ? series_.push({
        name: yName2,//,
        type: 'line',
        smooth: true,
        // yAxisIndex: 1,
        data: y2,
      }): null;

      return series_;
        // this.chart_single_power.setOption({
        //   grid: {
        //     left: 10,
        //     right: 32,
        //     bottom: 0,
        //     top: 45,
        //     containLabel: true
        //   },
        //   tooltip: {
        //     trigger: 'axis',
        //     position: function (point, params, dom, rect, size) {
        //       // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
        //       // 提示框位置
        //       var x = 0; // x坐标位置
        //       var y = 0; // y坐标位置
        //       // 当前鼠标位置
        //       var pointX = point[0];
        //       var pointY = point[1];
        //       // 提示框大小
        //       var boxWidth = size.contentSize[0];
        //       var boxHeight = size.contentSize[1];
        //       // boxWidth > pointX 说明鼠标左边放不下提示框
        //       if (boxWidth > pointX) {
        //         x = 5;
        //       } else { // 左边放的下
        //         x = pointX - boxWidth;
        //       }
        //       // boxHeight > pointY 说明鼠标上边放不下提示框
        //       if (boxHeight > pointY) {
        //         y = 5;
        //       } else { // 上边放得下
        //         y = pointY - boxHeight;
        //       }
        //       return [x, y];
        //     }
        //   },
        //   title: {
        //     left: 'center',
        //     text: legend_power == 1 ? legend_power[0].carNo : this.$t("statistics.powerConsumption"),//this.$t("statistics.powerConsumption")
        //   },
        //   xAxis: [
        //     {
        //       type: 'category',
        //       data: xAxis_data
        //     }
        //   ],
        //   yAxis: {
        //     type: 'value',
        //   },
        //   series: series_power,
        //   legend: {
        //     show: true,
        //     top: "10%",
        //     data: legend_power
        //   },
        // }, true);
        
    },
    setChart() {
      this.clearSingleVehicleCharts();
      // console.log("设置上面的折线图");
      var xAxis_data = [];
      var yAxis_data_power = [];
      var yAxis_data_oil = [];
      var selectVeh = [];//选择的车号
      var selectVehType = [];//选择的车号的类型，油车/电车
      var series_power = [];//折线图数据配置
      var series_oil = [];//折线图数据配置
      var legend_power = [];//折线图线配置
      var legend_oil = [];//折线图线配置
      var yAxis_data_fuelCell = [];
      var series_fuelCell = [];
      var legend_fuelCell = [];
      var yAxis_data_gas = [];
      var series_gas = [];
      var legend_gas = [];

      // 新加  用于统计单车的6大类
      var series_gasPower_s = [];
      var legend_gasPower_s = [];
      var series_oilPower_s = [];
      var legend_oilPower_s = [];
      var series_fuelCell_s = [];
      var legend_fuelCell_s = [];
      var series_gas_s = [];
      var legend_gas_s = [];
      var series_oil_s = [];
      var legend_oil_s = [];
      var series_power_s = [];
      var legend_power_s = [];

      this.chartAllOrSingle = (this.vehicles == "" || this.vehicles.length == this.allVehicles.length) ? true : false;//全选时展示车队图表信息，否则展示单车信息
      for (let k = 0; k < this.selectedVehicles.length; k++) {
        if (this.selectedVehicles[k].treeLevel == 5) {
          selectVehType.push(this.selectedVehicles[k].oilTypeID_New);
          selectVeh.push({vid:this.selectedVehicles[k].nodeValue,carNo:this.selectedVehicles[k].vehicleName});
        }
      }
      this.getCarType(selectVehType);

      if (!this.chartAllOrSingle) {
        // 1 柴油 2 气体机 3 油电 4 气电 5 纯电动 6 燃料电池

        // 添加标志判断是否为6大类中一个，只有一辆，是以车为维度画图，画车的总里程及其各类燃耗
        // 若两辆起的就以燃料类型为维度画图，画几大类燃料类型里多个车的燃耗比对
        let typeCount = {1: 0,2: 0,3: 0,4: 0,5: 0,6: 0};
        // 统计每类车辆数量
        for (let i = 0; i < selectVeh.length; i++) {
          const type = selectVehType[i];
          if (typeCount[type] !== undefined) {
            typeCount[type]++;
          }
        }
        for (let i = 0; i < selectVeh.length; i++) {

          const type = selectVehType[i];
          const count = typeCount[type]; // 当前类型有几辆车

          if(count == 1){
            // 1 柴油 2 气体机 3 油电 4 气电 5 纯电动 6 燃料电池
            switch(type){
              case 1:
                series_oil_s.push([]);
                legend_oil_s.push(selectVeh[i]);
                break;
              case 2:
                series_gas_s.push([]);
                legend_gas_s.push(selectVeh[i]);
                break;
              case 3:
                series_oilPower_s.push([]);
                legend_oilPower_s.push(selectVeh[i]);
                break;
              case 4:
                series_gasPower_s.push([]);
                legend_gasPower_s.push(selectVeh[i]);
                break;
              case 5:
                series_power_s.push([]);
                legend_power_s.push(selectVeh[i]);
                break;
              case 6:
                series_fuelCell_s.push([]);
                legend_fuelCell_s.push(selectVeh[i]);
                break;
            }
          }else if(count > 1){
            //分四大类，四个图
            // 柴油：1 或 3
            if (type === 1 || type === 3) {
              yAxis_data_oil.push([]);
              series_oil.push([]);
              legend_oil.push(selectVeh[i]);
            } 
            // 纯电动：5、4、3、6
            if (type === 5 || type === 4 || type === 3 || type === 6) {
              yAxis_data_power.push([]);
              series_power.push([]);
              legend_power.push(selectVeh[i]);
            } 
            // 燃料电池：6（注意：若先匹配纯电动，这里永远不会执行）
            if (type === 6) {
              yAxis_data_fuelCell.push([]);
              series_fuelCell.push([]);
              legend_fuelCell.push(selectVeh[i]);
            } 
            // 气体机：2 或 4
            if (type === 2 || type === 4) {
              yAxis_data_gas.push([]);
              series_gas.push([]);
              legend_gas.push(selectVeh[i]);
            }
          }
        }
        this.dataList.forEach((e) => {
          if (!xAxis_data.includes(e.statisticalTime)) {
            xAxis_data.push(e.statisticalTime);
          }
          xAxis_data.sort();
        })


        // 获取油车数据
        if(typeCount["1"] == 1){
          // 单车添加里程对比，1里程，2燃耗
          series_oil_s = this.setChartCompare(legend_oil_s,xAxis_data,"oilConsumption",this.$t("statistics.oilConsume"));
          let oilOption = this.setChartOption(legend_oil_s,xAxis_data,series_oil_s,"y",this.$t("statistics.oilConsume"));
          // series_oil_s = this.setChartCompare(legend_oil_s,xAxis_data,"oilConsumption",this.$t("statistics.oilConsume"),"powerConsumption",this.$t("statistics.powerConsumption"));
          // let oilOption = this.setChartOption(legend_oil_s,xAxis_data,series_oil_s,"y",this.$t("statistics.oilConsume"),this.$t("statistics.powerConsumption"));
          this.renderSingleVehicleChart(oilOption);
        }
        // 获取电车
        if(typeCount["5"] == 1){
          // 单车添加里程对比，1里程，2燃耗
          series_power_s = this.setChartCompare(legend_power_s,xAxis_data,"powerConsumption",this.$t("statistics.powerConsumption"));
          let option = this.setChartOption(legend_power_s,xAxis_data,series_power_s,"y",this.$t("statistics.powerConsumption"));
          this.renderSingleVehicleChart(option);
        }
        // 获取燃料电池
        if(typeCount["6"] == 1){
          // 单车添加里程对比，1里程，2燃耗
          series_fuelCell_s = this.setChartCompare(legend_fuelCell_s,xAxis_data,"HConsumption",this.$t("statistics.耗氢量")+'(kg)');
          let hOption = this.setChartOption(legend_fuelCell_s,xAxis_data,series_fuelCell_s,"y",this.$t("statistics.耗氢量")+'(kg)');
          this.renderSingleVehicleChart(hOption);
        }
        // 获取气体机
        if(typeCount["2"] == 1){
          // 单车添加里程对比，1里程，2燃耗
          series_gas_s = this.setChartCompare(legend_gas_s,xAxis_data,"GasConsumption",this.$t("statistics.气耗")+'('+this.gasUnit+')');
          let gasOption = this.setChartOption(legend_gas_s,xAxis_data,series_gas_s,"y",this.$t("statistics.气耗")+'('+this.gasUnit+')');
          this.renderSingleVehicleChart(gasOption);
        }
        // 新加混合的
        if(typeCount["3"] == 1){
          // 油电
          // 单车添加里程对比，1里程，2燃耗
          series_oilPower_s = this.setChartCompare(legend_oilPower_s,xAxis_data,"powerConsumption",this.$t("statistics.powerConsumption"),"oilConsumption",this.$t("statistics.oilConsume"));
          let Option = this.setChartOption(legend_oilPower_s,xAxis_data,series_oilPower_s,"y",this.$t("statistics.powerConsumption"),this.$t("statistics.oilConsume"));
          this.renderSingleVehicleChart(Option);
        }
        if(typeCount["4"] == 1){
          // 气电
          // 单车添加里程对比，1里程，2燃耗
          series_gasPower_s = this.setChartCompare(legend_gasPower_s,xAxis_data,"GasConsumption",this.$t("statistics.气耗")+'('+this.gasUnit+')',"powerConsumption",this.$t("statistics.powerConsumption"));
          let Option = this.setChartOption(legend_gasPower_s,xAxis_data,series_gasPower_s,"y",this.$t("statistics.气耗")+'('+this.gasUnit+')',this.$t("statistics.powerConsumption"));
          this.renderSingleVehicleChart(Option);
        }

        // 多车
        if(legend_oil.length > 0){
          series_oil = this.getChartData(legend_oil,yAxis_data_oil,xAxis_data,"oilConsumption")
        }
        if(legend_power.length > 0){
          series_power = this.getChartData(legend_power,yAxis_data_power,xAxis_data,"powerConsumption");
        }
        if(legend_fuelCell.length > 0){
          series_fuelCell = this.getChartData(legend_fuelCell,yAxis_data_fuelCell,xAxis_data,"HConsumption")
        }
        if(legend_gas.length > 0){
          series_gas = this.getChartData(legend_gas,yAxis_data_gas,xAxis_data,"GasConsumption")
        }
        // 1 柴油 2 气体机 3 油电 4 气电 5 纯电动 6 燃料电池
        if(legend_oil.length > 0){
          let oilOption = this.setChartOption(legend_oil,xAxis_data,series_oil,"y",this.$t("statistics.oilConsume"));
          this.chart_single_oil.setOption(oilOption,true);
        }

        if(legend_power.length > 0){
          let powerOption = this.setChartOption(legend_power,xAxis_data,series_power,"y",this.$t("statistics.powerConsumption"));
          this.chart_single_power.setOption(powerOption,true);
        }

        if(legend_fuelCell.length > 0){
          let hOption = this.setChartOption(legend_fuelCell,xAxis_data,series_fuelCell,"y",this.$t("statistics.耗氢量")+'(kg)');
          this.chart_single_fuelCell.setOption(hOption,true);
        } 

        if(legend_gas.length > 0){
          let gasOption = this.setChartOption(legend_gas,xAxis_data,series_gas,"y",this.$t("statistics.气耗"+'('+this.gasUnit+')'));
          this.chart_single_gas.setOption(gasOption,true);
        }

        // this.chart_single_fuelCell.setOption({
        //   grid: {
        //     left: 10,
        //     right: 32,
        //     bottom: 0,
        //     top: 45,
        //     containLabel: true
        //   },
        //   tooltip: {
        //     trigger: 'axis',
        //     position: function (point, params, dom, rect, size) {
        //       // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
        //       // 提示框位置
        //       var x = 0; // x坐标位置
        //       var y = 0; // y坐标位置
        //       // 当前鼠标位置
        //       var pointX = point[0];
        //       var pointY = point[1];
        //       // 提示框大小
        //       var boxWidth = size.contentSize[0];
        //       var boxHeight = size.contentSize[1];
        //       // boxWidth > pointX 说明鼠标左边放不下提示框
        //       if (boxWidth > pointX) {
        //         x = 5;
        //       } else { // 左边放的下
        //         x = pointX - boxWidth;
        //       }
        //       // boxHeight > pointY 说明鼠标上边放不下提示框
        //       if (boxHeight > pointY) {
        //         y = 5;
        //       } else { // 上边放得下
        //         y = pointY - boxHeight;
        //       }
        //       return [x, y];
        //     }
        //   },
        //   title: {
        //     left: 'center',
        //     text: this.$t("statistics.耗氢量")
        //   },
        //   xAxis: [
        //     {
        //       type: 'category',
        //       data: xAxis_data
        //     }
        //   ],
        //   yAxis: {
        //     type: 'value',
        //   },
        //   series: series_fuelCell,
        //   legend: {
        //     show: true,
        //     top: "10%",
        //     data: legend_fuelCell
        //   },
        // }, true);
        // this.chart_single_gas.setOption({
        //   grid: {
        //     left: 10,
        //     right: 32,
        //     bottom: 0,
        //     top: 45,
        //     containLabel: true
        //   },
        //   tooltip: {
        //     trigger: 'axis',
        //     position: function (point, params, dom, rect, size) {
        //       // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
        //       // 提示框位置
        //       var x = 0; // x坐标位置
        //       var y = 0; // y坐标位置
        //       // 当前鼠标位置
        //       var pointX = point[0];
        //       var pointY = point[1];
        //       // 提示框大小
        //       var boxWidth = size.contentSize[0];
        //       var boxHeight = size.contentSize[1];
        //       // boxWidth > pointX 说明鼠标左边放不下提示框
        //       if (boxWidth > pointX) {
        //         x = 5;
        //       } else { // 左边放的下
        //         x = pointX - boxWidth;
        //       }
        //       // boxHeight > pointY 说明鼠标上边放不下提示框
        //       if (boxHeight > pointY) {
        //         y = 5;
        //       } else { // 上边放得下
        //         y = pointY - boxHeight;
        //       }
        //       return [x, y];
        //     }
        //   },
        //   title: {
        //     left: 'center',
        //     text: this.$t("statistics.气耗")
        //   },
        //   xAxis: [
        //     {
        //       type: 'category',
        //       data: xAxis_data
        //     }
        //   ],
        //   yAxis: {
        //     type: 'value',
        //   },
        //   series: series_gas,
        //   legend: {
        //     show: true,
        //     top: "10%",
        //     data: legend_gas
        //   },
        // }, true);
      }
    },
    setChartOption(legend,xAxis_data,series,yAxis,title,title2){
      let legendSin = title2 ? [this.$t("driver.里程"),title,title2] : [this.$t("driver.里程"),title];
      let chartOption = {
        grid: {
          left: 10,
          right: 32,
          bottom: 0,
          top: 45,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          position: function (point, params, dom, rect, size) {
            // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
            // 提示框位置
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置
            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];
            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];
            // boxWidth > pointX 说明鼠标左边放不下提示框
            if (boxWidth > pointX) {
              x = 5;
            } else { // 左边放的下
              x = pointX - boxWidth;
            }
            // boxHeight > pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else { // 上边放得下
              y = pointY - boxHeight;
            }
            return [x, y];
          }
        },
        title: {
          left: 'center',
          text: legend.length == 1 ? legend[0].carNo : title,//this.$t("statistics.powerConsumption")
        },
        xAxis: [
          {
            type: 'category',
            data: xAxis_data
          }
        ],
        // yAxis:legend.length == 1 ? yAxis:{type: 'value'},
        yAxis:{type: 'value'},
        series: series,
        legend: {
          show: true,
          top: "10%",
          data: legend.length == 1 ? legendSin : legend
        },
      }
      return chartOption;

      // this.chart_single_oil.setOption({
      //   grid: {
      //     left: 10,
      //     right: 32,
      //     bottom: 0,
      //     top: 45,
      //     containLabel: true
      //   },
      //   tooltip: {
      //     trigger: 'axis',
      //     position: function (point, params, dom, rect, size) {
      //       // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
      //       // 提示框位置
      //       var x = 0; // x坐标位置
      //       var y = 0; // y坐标位置
      //       // 当前鼠标位置
      //       var pointX = point[0];
      //       var pointY = point[1];
      //       // 提示框大小
      //       var boxWidth = size.contentSize[0];
      //       var boxHeight = size.contentSize[1];
      //       // boxWidth > pointX 说明鼠标左边放不下提示框
      //       if (boxWidth > pointX) {
      //         x = 5;
      //       } else { // 左边放的下
      //         x = pointX - boxWidth;
      //       }
      //       // boxHeight > pointY 说明鼠标上边放不下提示框
      //       if (boxHeight > pointY) {
      //         y = 5;
      //       } else { // 上边放得下
      //         y = pointY - boxHeight;
      //       }
      //       return [x, y];
      //     }
      //   },
      //   title: {
      //     left: 'center',
      //     text: this.$t("statistics.oilConsume")
      //   },
      //   xAxis: [
      //     {
      //       type: 'category',
      //       data: xAxis_data
      //     }
      //   ],
      //   yAxis: {
      //     type: 'value',
      //   },
      //   series: series_oil,
      //   legend: {
      //     show: true,
      //     top: "10%",
      //     data: legend_oil
      //   },
      // }, true);
    },
    getChartData(legend,yAxis_data,xAxis_data,fuelType){

      let series = [];
      for (let i = 0; i < legend.length; i++) {
        let item = 0  //
        let y = yAxis_data[i];
        tiaochu: for (let dt = 0; dt < this.dataList.length; dt++) {  //遍历dataList数据，找跟x坐标时间对应的数据，一个车号在一个时间只有一条数据(一对一对一关系)
          if (this.dataList[dt].vid == legend[i].vid) {   //锁定车号，找时间点对应--数据
            for (item; item < xAxis_data.length;) {   //根据时间为x坐标来push添加对应时间点的y轴数据
              if (xAxis_data[item] == this.dataList[dt].statisticalTime) {
                y.push(this.dataList[dt][fuelType]);
                item = item + 1;
                
                //  continue;
                continue tiaochu;  //一个车号在一个时间点只有一个数据，找到后说明应该往datalist的下一条数据继续找下一个时间点的对应数据
                //如果不跳出，会用该已经找到的dataList继续往下找时间点，但dataList和时间点是一对一关系，就会进入else语句，添加进0的无用数据
              }
              else {
                y.push(0);
                item = item + 1;  //不跳出，因为该条dataList数据还没找到对应时间点，应在时间里继续遍历找对应时间点
              }
            }
          }
        }
        series[i] = {
          name: legend[i].carNo,
          type: 'line',
          smooth: true,
          data: y,
        }
      }
      // console.log(series);
      return series;
      // for (let i = 0; i < legend_power.length; i++) {
      //   let item = 0  //
      //   let y_power = yAxis_data_power[i];
      //   tiaochu: for (let dt = 0; dt < this.dataList.length; dt++) {  //遍历dataList数据，找跟x坐标时间对应的数据，一个车号在一个时间只有一条数据(一对一对一关系)
      //     if (this.dataList[dt].vid == legend_power[i].vid) {   //锁定车号，找时间点对应--数据
      //       for (item; item < xAxis_data.length;) {   //根据时间为x坐标来push添加对应时间点的y轴数据
      //         if (xAxis_data[item] == this.dataList[dt].statisticalTime) {
      //           y_power.push(this.dataList[dt].powerConsumption);
      //           item = item + 1;
      //           //  continue;
      //           continue tiaochu;  //一个车号在一个时间点只有一个数据，找到后说明应该往datalist的下一条数据继续找下一个时间点的对应数据
      //           //如果不跳出，会用该已经找到的dataList继续往下找时间点，但dataList和时间点是一对一关系，就会进入else语句，添加进0的无用数据
      //         }
      //         else {
      //           y_power.push(0);
      //           item = item + 1;  //不跳出，因为该条dataList数据还没找到对应时间点，应在时间里继续遍历找对应时间点
      //           // continue;
      //           // continue tiaochu;
      //         }
      //       }
      //     }
      //   }
      //   series_power[i] = {
      //     name: legend_power[i].carNo,
      //     type: 'line',
      //     smooth: true,
      //     data: yAxis_data_power[i],
      //   }
      // }
    },
    getList(resetChart) {
      let queryType = 0;
      switch(this.activeName){
        case "first":
          queryType = 0;
          break;
        case "second":
          queryType = 1;
          break;
        case "third":
          queryType = 2;
          break;
      }
      this.loading = true;
      this.$api
        .energyInfo({
          companyID: this.$store.getters.operator.CompanyId,
          vehicles: this.vehicles,//"100738",
          queryType: queryType,//this.activeName == "first" ? 0 : 1,
          beginDate: this.beginDate,
          endDate: this.endDate,
          OperatorID: this.$store.getters.operator.OperatorId,

          PageNo: this.isAllVehicles ? this.currentPage : 1,
          PageSize: this.isAllVehicles ? this.pageSize : 1000,
          IsExport: 0, // 0是查询 1是下载
          Language: this.LanguageId,
          Params: this.SortFlag ? this.Params : this.isAllVehicles ? this.defalteQuery.Params : undefined,
          SortFlag: this.SortFlag ? this.SortFlag : this.isAllVehicles ? this.defalteQuery.SortFlag : undefined,
          CompanyFlag: 0,
          Unit: this.gasUnit == 'm³' ? 'm3' : this.gasUnit,
        })
        .then((res) => {
          if (res && res.code == 200) {
            this.loading = false;
            this.dataList = res.data;
            this.total = res.recordsTotal;

            resetChart ? null : this.setChart(this.dataList);

            if (this.total == 0) {
              this.$message.info(this.$t("statistics.noData"));
            }
          }
        })
        .catch((e) => {
          this.loading = false;
        })
    },
    download() {

      this.vehicles = this.getSelectedVehicles();
      var that = this;
      that.downloading = true;
      this.$api
        .downEnergyInfo({
          companyID: this.$store.getters.operator.CompanyId,
          vehicles: this.vehicles,//"100738",
          queryType: this.activeName == "first" ? 0 : 1,
          beginDate: this.beginDate,
          endDate: this.endDate,
          OperatorID: this.$store.getters.operator.OperatorId,
          IsExport: 1, // 0是查询 1是下载
          Language: this.LanguageId,
          CompanyFlag: 0,
          Unit: this.gasUnit == 'm³' ? 'm3' : this.gasUnit,
        })
        .then((res) => {
          let blob = new Blob([res], {
            type: "application/vnd.ms-excel;charset=utf-8",
          }); // 重点代码
          let a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.setAttribute(
            "download",
            that.type == "0" ? that.$t("statistics.月燃耗") + that.$t("public.download") + `_${that.timestampToTime(new Date().getTime())}.xlsx`
              : that.$t("statistics.日燃耗") + that.$t("public.download") + `_${that.timestampToTime(new Date().getTime())}.xlsx`
          ); // 表名，自定义
          a.click(); // 执行下载
          window.URL.revokeObjectURL(blob); // 释放ur
          that.downloading = false;
        })
        .catch((error) => {
          console.error("下载失败", error);
          that.downloading = false;
        });
    },
    //时间戳转换为日期格式
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间数为10位篇*1000，时间数为13位的话不需乘1000
      var Y = date.getFullYear();
      var M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var D = date.getDate();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      return Y + M + D + h + m + s;
    },
    toFixed2(val) {
      if (Number.isInteger(val)) return val;
      return val.toFixed(2);
    },
    quickQuery(val) {
      if (this.activeName == "first") {
        this.showMBtn = val
      } else if(this.activeName == "second"){
        this.showDBtn = val;
      } else{
        this.showYBtn = val;
      }
      let day = 24 * 60 * 60 * 1000;
      let getDay = new Date().getDay() == 0 ? 7 : new Date().getDay();//getDay星期天是0;
      let getNowMonth = new Date().getMonth() + 1 + "";
      getNowMonth = getNowMonth.length == 2 ? getNowMonth : ("00" + getNowMonth).substring(("" + getNowMonth).length);
      let getLastMonth = new Date().getMonth() + "";
      getLastMonth = getLastMonth.length == 2 ? getLastMonth : ("00" + getLastMonth).substring(("" + getLastMonth).length);
      let today = new Date();
      if (this.activeName == "first") {
        switch (val) {
          case 0: //本月
            this.beginDate = this.format(today, "yyyy-" + getNowMonth + "-01");
            this.endDate = this.format(today, "yyyy-" + getNowMonth + "-" + this.getCountDays(this.beginDate));
            // console.log(this.beginDate,this.endDate);
            break;
          case 1:  //上月
            //跨年特殊处理
            if (getLastMonth == "00") {
              this.beginDate = this.format(today, today.getFullYear() - 1 + "-12-01");
              this.endDate = this.format(today, today.getFullYear() - 1 + "-12-31");
            } else {
              this.beginDate = this.format(today, "yyyy-" + getLastMonth + "-01");
              this.endDate = this.format(today, "yyyy-" + getLastMonth + "-" + this.getCountDays(this.beginDate));
            }
            // console.log(this.beginDate,this.endDate);
            break;
          case 2:  //上上月
            let month = new Date().getMonth() - 1 + "";
            month = month.length == 2 ? month : ("00" + month).substring(("" + month).length);
            //跨年特殊处理
            if (month == "-1") {
              this.beginDate = this.format(today, today.getFullYear() - 1 + "-11-01");
              this.endDate = this.format(today, today.getFullYear() - 1 + "-11-30");
            } else if (month == "00") {
              this.beginDate = this.format(today, today.getFullYear() - 1 + "-12-01");
              this.endDate = this.format(today, today.getFullYear() - 1 + "-12-31");
            } else {
              this.beginDate = this.format(today, "yyyy-" + month + "-01");
              this.endDate = this.format(today, "yyyy-" + month + "-" + this.getCountDays(this.beginDate));
            }
            // console.log(this.beginDate,this.endDate);
            break;
        }
      }
      else if(this.activeName == "second"){
        switch (val) {
          case 0:
            //跨年特殊处理
            if (getLastMonth == "00") {
              this.beginDate = this.format(today, today.getFullYear() - 1 + "-12-01");
              this.endDate = this.format(today, today.getFullYear() - 1 + "-12-31");
            } else {
              this.beginDate = this.format(today, "yyyy-" + getLastMonth + "-01");
              this.endDate = this.format(new Date(new Date(this.beginDate).getTime() + (this.getCountDays(this.beginDate) - 1) * day), "yyyy-MM-dd");
            }
            // console.log(this.beginDate,this.endDate);
            break;
          case 1:  //本月
            this.beginDate = this.format(today, "yyyy-" + getNowMonth + "-01");
            this.endDate = this.format(new Date(today.getTime()), "yyyy-MM-dd");
            // console.log(this.beginDate,this.endDate);
            break;
          case 2:
            this.beginDate = this.format(new Date(today.getTime() - (getDay + 6) * day), "yyyy-MM-dd");
            this.endDate = this.format(new Date(today.getTime() - getDay * day), "yyyy-MM-dd");
            // console.log(this.beginDate,this.endDate);
            break;
          case 3:
            this.beginDate = this.format(new Date(today.getTime() - (getDay - 1) * day), "yyyy-MM-dd");
            this.endDate = this.format(new Date(today.getTime()), "yyyy-MM-dd");
            // console.log(this.beginDate,this.endDate);
            break;
          case 4://前天
            this.beginDate = this.format(new Date(today.getTime() - 2 * day), "yyyy-MM-dd");
            this.endDate = this.format(new Date(today.getTime() - 2 * day), "yyyy-MM-dd");
            // console.log(this.beginDate,this.endDate);
            break;
          case 5:
            this.beginDate = this.format(new Date(today.getTime() - day), "yyyy-MM-dd");
            this.endDate = this.format(new Date(today.getTime() - day), "yyyy-MM-dd")
            // console.log(this.beginDate,this.endDate);
            break;
          case 6:
            this.beginDate = this.format(today, "yyyy-MM-dd");
            this.endDate = this.format(new Date(today.getTime()), "yyyy-MM-dd");
            // console.log(this.beginDate,this.endDate);
            break;
        }
      }else if(this.activeName == "third"){
        let nowYear = today.getFullYear();
        switch(val){
          case 0:
            this.beginDate = nowYear+"-01-01";
            this.endDate = nowYear+"-12-31";
            break;
          case 1:
            this.beginDate = (nowYear - 1)+"-01-01";
            this.endDate = (nowYear - 1)+"-12-31";
            break;
          case 2:
            this.beginDate = (nowYear - 2)+"-01-01";
            this.endDate = (nowYear - 2)+"-12-31";
            break;
        }
      }

      this.vehicles = this.getSelectedVehicles();
      this.isAllVehicles = this.vehicles == "" ? true : this.vehicles.split(",").length == this.tree[this.$store.getters.operator.CompanyId].totalCount;
      this.currentPage = 1;
      this.$refs.table.clearSort();
      this.SortFlag = undefined;//清空排序条件
      this.getList();
      this.queryAllEnergyData();
    },
    format(datetime, format) {
      var o = {
        "M+": datetime.getMonth() + 1, //month
        "d+": datetime.getDate(), //day
        "h+": datetime.getHours(), //hour
        "m+": datetime.getMinutes(), //minute
        "s+": datetime.getSeconds(), //second
        "q+": Math.floor((datetime.getMonth() + 3) / 3), //quarter
        S: datetime.getMilliseconds(), //millisecond
      };
      if (/(y+)/.test(format)) {
        format = format.replace(
          /(y+)/.exec(format)[0],
          (datetime.getFullYear() + "").substring(4 - /(y+)/.exec(format)[0].length)
        );
      }

      for (var k in o) {
        // console.log(o[k]);
        if (new RegExp("(" + k + ")").test(format)) {
          let item = eval("/(" + k + ")/.exec(format)[0]")
          format = format.replace(
            item,
            item.length == 1 ? o[k] : ("00" + o[k]).substring(("" + o[k]).length)
          );
          // console.log(format,"0.0");
        }
      }
      return format;
    },
    // 获取一个月有多少天，curDate是开始日期，获取这个日期的月份的天数
    getCountDays(curDate) {
      const d = new Date(curDate)
      const y = d.getFullYear()
      //获取本月的下一个月
      const m = d.getMonth() + 1
      // 下一个月的第0天就是这个月的天数
      const days = new Date(y, m, 0).getDate()
      return days
    },
    sizeChange(val){
      this.pageSize = val;
      this.currentPage = 1;
      if (this.isAllVehicles) {
        this.getList();
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.isAllVehicles) {
        this.getList();
      }
      this.$refs.table.doLayout();//对 Table 进行重新布局。
    },
    fold() {
      this.showChartConspt = !this.showChartConspt;
      // if(this.showChartConspt){
      //   this.$nextTick(function () {
      //     var myEvent = new Event("resize");
      //     window.dispatchEvent(myEvent);
      //   });
      // }
      if (this.showChartConspt) {
        setTimeout(() => {
          var myEvent = new Event("resize");
          window.dispatchEvent(myEvent);
        }, 0)

      }
    },
    initChart() {
      this.energyDataChart = echarts.init(document.getElementById("energyDataChart" + this.type));
      this.chart_fleetConspt = echarts.init(document.getElementById("chart_fleetConspt" + this.type));
      this.chart_fleetMileage = echarts.init(document.getElementById("chart_fleetMileage" + this.type));
      this.chart_avgConspt = echarts.init(document.getElementById("chart_avgConspt" + this.type));
      this.chart_fleetOilConspt = echarts.init(document.getElementById("chart_fleetOilConspt" + this.type));
      this.chart_fleetOilMileage = echarts.init(document.getElementById("chart_fleetOilMileage" + this.type));
      this.chart_avgOilConspt = echarts.init(document.getElementById("chart_avgOilConspt" + this.type));
      this.chart_fleetfuelCellConspt = echarts.init(document.getElementById("chart_fleetfuelCellConspt" + this.type));
      this.chart_fleetfuelCellMileage = echarts.init(document.getElementById("chart_fleetfuelCellMileage" + this.type));
      this.chart_avgfuelCellConspt = echarts.init(document.getElementById("chart_avgfuelCellConspt" + this.type));
      this.chart_fleetGasConspt = echarts.init(document.getElementById("chart_fleetGasConspt" + this.type));
      this.chart_fleetGasMileage = echarts.init(document.getElementById("chart_fleetGasMileage" + this.type));
      this.chart_avgGasConspt = echarts.init(document.getElementById("chart_avgGasConspt" + this.type));

      // this.chart_conspt = echarts.init(document.getElementById("chart_conspt"+this.type));
      this.chart_single_power = echarts.init(document.getElementById("chart_single_power" + this.type));
      this.chart_single_oil = echarts.init(document.getElementById("chart_single_oil" + this.type));
      this.chart_single_fuelCell = echarts.init(document.getElementById("chart_single_fuelCell" + this.type));
      this.chart_single_gas = echarts.init(document.getElementById("chart_single_gas" + this.type));

      var option = {
        grid: {
          left: 16,
          right: 16,
          bottom: '3%',
          top: 2,
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLabel: {
              color: "rgba(15,26,58,0.5)",
              fontSize: 12
            },
            axisLine: {
              lineStyle: {
                color: "rgba(15,26,58,0.5)",
              }
            },
            data: []
          }
        ],
        yAxis: [
          {
            show: false,
            axisLine: {
              show: false
            },
            type: 'value',
            axisTick: {
              show: false,  //刻度线
            },
            axisLabel: {
              show: false, //隐藏刻度值
            },
          }
        ],
        series: [
          {
            name: 'Email',
            type: 'line',
            // stack: 'Total',
            smooth: true,
            symbol: "none",
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#2A7AFF' // 0% 处的颜色
                }, {
                  offset: 1, color: '#ffffff' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              },

            },
            lineStyle: {
              color: "#2A7AFF"
            },
            data: []
          },
        ]
      };
      var optionSingle = {
        grid: {
          left: 30,
          right: 32,
          bottom: 0,
          top: 45,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          position: function (point, params, dom, rect, size) {
            // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
            // 提示框位置
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置

            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];

            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];

            // boxWidth > pointX 说明鼠标左边放不下提示框
            if (boxWidth > pointX) {
              x = 5;
            } else { // 左边放的下
              x = pointX - boxWidth;
            }

            // boxHeight > pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else { // 上边放得下
              y = pointY - boxHeight;
            }

            return [x, y];
          }
        },
        title: {
          left: 'center',
          text: '耗电量(度)'
        },
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            type: 'line',
            smooth: true,
            data: []
          }
        ]
      }

      this.chart_fleetConspt.setOption(option);
      this.chart_fleetMileage.setOption(option);
      this.chart_avgConspt.setOption(option);
      this.chart_fleetOilConspt.setOption(option);
      this.chart_fleetOilMileage.setOption(option);
      this.chart_avgOilConspt.setOption(option);
      this.chart_fleetfuelCellConspt.setOption(option);
      this.chart_fleetfuelCellMileage.setOption(option);
      this.chart_avgfuelCellConspt.setOption(option);
      this.chart_fleetGasConspt.setOption(option);
      this.chart_fleetGasMileage.setOption(option);
      this.chart_avgGasConspt.setOption(option);
      this.chart_single_power.setOption(optionSingle);
      this.chart_single_oil.setOption(optionSingle);
      this.chart_single_fuelCell.setOption(optionSingle);
      this.chart_single_gas.setOption(optionSingle);

    }
  },
  created() {
    this.winHeight = window.innerHeight;
    if (this.winHeight < 830) {
      this.showChartConspt = false;
    }
  },
  mounted() {
      const currentPath = this.$route.path
    // 从全局变量中取出对应路由的开始时间
    const startTime = settings.routeStartTime[currentPath]
    if (startTime) {
      // 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
      const renderTime = Date.now() - startTime
      console.log(`路由 ${currentPath} 渲染耗时：${renderTime}`)
      // 可选：上报到后端或日志系统
      // reportRenderTime(currentPath, renderTime)

      // 清除已计算的开始时间，避免重复计算
      delete settings.routeStartTime[currentPath]
    }
    this.LanguageId = language(this.$store.getters.locale)
    let t = new Date();
    var n = new Date(t.getFullYear(), t.getMonth() - 2, 1);
    this.searchMTime = [new Date(n), new Date];
    this.searchYTime = [new Date(t.getFullYear()-2, 1,1), new Date];
    this.$nextTick(() => {
      this.initChart();
      // this.getEnergyList();
      this.setResize();
    });
    window.addEventListener('resize', this.setResize);
    this.options = [
      {
        value: 0,
        label: this.$t("time.generalQuery")
      },
      {
        value: 1,
        label: this.$t("time.quickQuery"),
      }
    ];
    this.monthBtns = [
      {
        value: 0,
        label: this.$t("time.thisMonth"),
      },
      {
        value: 1,
        label: this.$t("time.lastMonth"),
      },
      {
        value: 2,
        label: this.$t("time.twoMonthsGgo"),
      },
    ];
    this.dayBtns = [
      {
        value: 0,
        label: this.$t("time.lastMonth")
      },
      {
        value: 1,
        label: this.$t("time.thisMonth")
      },
      {
        value: 2,
        label: this.$t("time.lastWeek")
      },
      {
        value: 3,
        label: this.$t("time.thisWeek")
      },
      {
        value: 4,
        label: this.$t("time.beforyesterday")
      },
      {
        value: 5,
        label: this.$t("time.yesterday")
      },
      // {
      //   value:6,
      //   label:this.$t("time.today")
      // },
    ];
    this.yearBtns = [
      {
        value: 0,
        label: this.$t("time.今年"),
      },
      {
        value: 1,
        label: this.$t("time.去年"),
      },
      {
        value: 2,
        label: this.$t("time.前年"),
      },
    ]

    this.optionsType = this.energyTypes[0];

    // 账号企业拥有的能源类型，固定的不随选择器变化
    this.hasPower = this.energyTypes.includes("3")||this.energyTypes.includes("4")||this.energyTypes.includes("5")||this.energyTypes.includes("6");
    this.hasOil = this.energyTypes.includes("1")||this.energyTypes.includes("3");
    this.hasGas = this.energyTypes.includes("2")||this.energyTypes.includes("4");
    this.hasH = this.energyTypes.includes("6");
    //只有一种，不显示选择器，直接显示该类型，多种才提供选择
    if(this.energyTypes.length == 1){
      this.mulFuelTypeSelect = false;
    }
    for (var item = 0; item < this.appVehicles.data.length; item++) {
      if (this.appVehicles.data[item].treeLevel == 5) {
        // i++;
        this.allVehicles = this.allVehicles + this.appVehicles.data[item].nodeValue + ",";
      }
    }
    this.allVehicles = this.allVehicles.substring(0, this.allVehicles.length - 1);
    if (this.Init) {
      this.handleQuery();
      this.$nextTick(() => {
        this.getEnergyList();
      });
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.setResize)
  },
  activated(){
    this.setResize();
    window.addEventListener('resize',this.setResize)
  },
  deactivated(){
    window.removeEventListener('resize', this.setResize)
  },
}
</script>

<style lang="scss" scoped>
.el-card {
  background-color: transparent;
}

.pagination {

  ::v-deep .el-pagination button:disabled,
  .el-pager li,
  .el-pagination .btn-prev,
  .el-pagination .btn-next {
    background-color: transparent !important;
  }

}

.container {
  ::v-deep .el-table tr {
    background: transparent;
  }

  ::v-deep .el-table {
    background: transparent;
  }

  ::v-deep .el-table td {
    background: transparent;
  }
}

.iconfont {
  font-size: 10px;
}

.foldBtn {
  ::v-deep .el-button--mini {
    padding: 5px 10px !important;
  }
}

.pcVal {
  font-size: 15px;
  font-weight: bold;
}

.comptVal {
  font-size: 24px;
  margin-right: 5px;
  font-weight: bold;
}

.card ::v-deep {
  .el-card__header {
    /* background: #E8F0FF; */
    /* height: 35px; */
    padding: 15px 9px;
    /* font-weight: bold; */
    font-size: 14px;
  }

  .el-card__body {
    padding: 0;
  }

}

.el-icon-top:before {
  color: red;
  font-size: 24px;
  font-weight: bold;
}


.el-range-editor.el-input__inner {
  padding: 3px 5px;
}

.tabs {
  ::v-deep .el-tabs__item {
    padding: 0 10px !important;
    font-weight: bold;
    font-size: 14px;
  }

  ::v-deep .el-tabs__nav-wrap {
    &::after {
      display: none;
    }
  }

  ::v-deep .el-tabs__header {
    margin: 0;
  }

  ::v-deep .el-tabs__active-bar {
    height: 3px;
    border-radius: 2px;
  }
}

.el-form-item {
  margin-bottom: 0px !important;
}

 
</style>